import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { Stage, Layer, Rect, Transformer, Line } from "react-konva";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Text as Text1 } from 'react-konva';
import { apiUrl, apiShapes, apiLocal } from '../constant/constant'
import Buttons from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Delete from '../assests/delete.svg';
import Reset from '../assests/reset-zoom.svg';
import ZoomAdd from '../assests/zoom-in.svg';
import ZoomSub from '../assests/zoom-out.svg';
import Konva from 'konva';
import html2canvas from "html2canvas";
import axios from 'axios';
import jsPDF from "jspdf";
import AdImage from "../tool/Image";
import TextDisplay from "../tool/Text";
import Guides from "@scena/react-guides";
import clock from '../assests/design/clock.png'
import clockstand from '../assests/design/clockstand.png'
import gram from '../assests/design/gram.png'
import kilogram from '../assests/design/kilogram.png'
import weight from '../assests/design/weight.png'
import logo from '../assests/logo.svg'
import underline1 from '../assests/underline1.svg'
import rightAlign from '../assests/right.svg'
import centerAlign from '../assests/center.svg'
import leftAlign from '../assests/left.svg'
import italic1 from '../assests/italic.svg'
import Arrows from '../assests/Arrows.svg'
import bold1 from '../assests/bold.svg'
import duplicate from '../assests/duplicate.png'
import divide from '../assests/divided.png'
import column from '../assests/rectangles.png'
import rectangles from '../assests/rectangle.svg'
import piechart from '../assests/piechart.png'
import abacus from '../assests/abacus.png'
import calendar from '../assests/calendar.png'
import deelte from '../assests/deelte.svg'
import barchart from '../assests/barchart.png'
import addition from '../assests/addiction.png'
import download from '../assests/download.png'
import save from '../assests/save.png'
import drag from '../assests/drag.svg'
import Undo from '../assests/Undo.svg'
import Redo from '../assests/Redo.svg'
import addNew from '../assests/addnew.svg'
import borderImage1 from '../assests/borderImage1.svg'
import borderImage2 from '../assests/borderImage2.svg'
import borderImage3 from '../assests/borderImage3.svg'
import borderImage4 from '../assests/borderImage4.svg'
import orientation from '../assests/orientation.svg'
import pageNo from '../assests/pageno.svg'
import abacus1 from '../assests/abacus-game.png'
import borderImage from '../assests/border.svg'
import elementicon from '../assests/nav/elementicon.svg'
import templateicon from '../assests/nav/templateicon.svg'
import mathsicon from '../assests/nav/mathsicon.svg'
import scienceicon from '../assests/nav/scienceicon.svg'
import cardsicon from '../assests/nav/cardicon.svg'
import foldericon from '../assests/nav/foldericon.svg'
import graphicon from '../assests/nav/graphicon.svg'
import mapicon from '../assests/nav/mapicon.svg'
import tableicon from '../assests/nav/tableicon.svg'
import puzzleicon from '../assests/nav/puzzleicon.svg'
import uploadicon from '../assests/nav/uploadicon.svg'
import Tables from '../assests/nav/tables.png'
import grid from '../assests/grid.png'
import share from '../assests/share.svg'
import { Dropdown, Menu, Table } from 'antd'
import { Box, Button, Input, SimpleGrid, Select, Text, useToast, useDisclosure, Flex, Tabs, TabList, TabPanels, Tab, TabPanel, NumberInput, NumberInputField, border } from "@chakra-ui/react";
import '../App.css';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react'
import { Chart, registerables } from 'chart.js';
import Calendar from 'reactjs-availability-calendar'
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import FlipToBackIcon from '@mui/icons-material/FlipToBack';
import FlipToFrontIcon from '@mui/icons-material/FlipToFront';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Respo from './Respo';


const Dashboard = () => {
  const recentPages = useLocation();
  const history = useNavigate()
  Chart.register(...registerables)
  const [btncheck, setbtncheck] = useState(0)
  const [pagenumber, setPagenumber] = useState(false)
  const [images, setImages] = React.useState([]);
  const [img, setImg] = React.useState([]);
  const [texts, setTexts] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState(null);
  const [font, setFont] = React.useState({ size: 32, family: "Arial", letterSpacing: 1, lineHeight: 1, fontStyle: '', align: '', textDecoration: '' });
  const [deletevalue, setdeletevalue] = React.useState()
  const [nodesArray, setNodes] = React.useState([]);

  const trRef = React.useRef();
  const layerRef = React.useRef();
  const activeRef = React.useRef();
  const cancelRef = React.useRef();
  const itemRef = React.useRef();
  const stageRef = React.useRef();

  const checkDeselect = (e) => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      setSelectedId(null);
      setTextEdit(false)
      setImageEdit(false)
      trRef.current.nodes([]);  //
      setNodes([]);               //
    }
  };

  const selectionRectRef = React.useRef();
  const selection = React.useRef({
    visible: false,
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  });

  const updateSelectionRect = () => {
    const node = selectionRectRef.current;
    node.setAttrs({
      visible: selection.current.visible,
      x: Math.min(selection.current.x1, selection.current.x2),
      y: Math.min(selection.current.y1, selection.current.y2),
      width: Math.abs(selection.current.x1 - selection.current.x2),
      height: Math.abs(selection.current.y1 - selection.current.y2),
      fill: selectedId ? "rgba(0, 161, 255, 0.3)" : ''
    });
    // node.getLayer().batchDraw();
  };

  const oldPos = React.useRef(null);
  const onMouseDown = (e) => {
    const isElement = e.target.findAncestor(".elements-container");
    const isTransformer = e.target.findAncestor("Transformer");
    if (isElement || isTransformer) {
      return;
    }

    const pos = e.target.getStage().getPointerPosition();
    selection.current.visible = true;
    selection.current.x1 = pos.x;
    selection.current.y1 = pos.y;
    selection.current.x2 = pos.x;
    selection.current.y2 = pos.y;
    updateSelectionRect();
  };

  const onMouseMove = (e) => {
    if (!selection.current.visible) {
      return;
    }
    const pos = e.target.getStage().getPointerPosition();
    selection.current.x2 = pos.x;
    selection.current.y2 = pos.y;
    updateSelectionRect();
  };

  const onMouseUp = () => {
    oldPos.current = null;
    if (!selection.current.visible) {
      return;
    }
    const selBox = selectionRectRef.current.getClientRect();
    const elements = [];
    layerRef.current.find(".rectangle").forEach((elementNode) => {
      const elBox = elementNode.getClientRect();
      if (Konva.Util.haveIntersection(selBox, elBox)) {
        elements.push(elementNode);
      }
    });
  
    trRef.current.nodes(elements);
    selection.current.visible = false;
    // disable click event
    Konva.listenClickTap = false;
    updateSelectionRect();
  };

  const [flag, setflag] = React.useState(null);
  const [bol, setbol] = React.useState(false);
  const [l, setl] = React.useState();
  const [file, setFile] = React.useState()
  const [update, setupdate] = React.useState(-1);
  const { onClose, isOpen, onOpen } = useDisclosure();

  //models
  const [hours, setHours] = React.useState("");
  const [mins, setmins] = React.useState("");
  const [kg, setkg] = React.useState("");
  const [g, setg] = React.useState("");
  const [page, setPage] = React.useState([]);
  const [page1, setPage1] = React.useState([]);
  const [color, setcolor] = React.useState('black');
  const [data, setData] = React.useState([])
  const [number, setNumber] = React.useState(0);
  const [scale, setscale] = React.useState({ scaleX: '', scaleY: '' });
  const [visible1, setvisible1] = React.useState(false)
  const [visible2, setvisible2] = React.useState(false)
  const [textedit, setTextEdit] = React.useState(false)
  const [rightDrop, setRightDrop] = React.useState(false);
  const [imageedit, setImageEdit] = React.useState(false)
  const [undoImage, setUndoImage] = React.useState([])
  const [undoData, setUndoData] = React.useState([]);
  const [imageDrop, setImageDrop] = React.useState(false);
  const [borderStyleDashed, setBorderStyleDashed] = React.useState(0);
  const [templateData, setTemplateData] = React.useState([]);
  const [templateImage, setTemplateImage] = React.useState([]);
  const [diagram, setdiagram] = React.useState();
  const [borderShadow, setBorderShadow] = React.useState(false);
  const [DeleteUndo, setDeleteUndo] = React.useState([]);
  const [redo, setRedo] = React.useState([]);
  const [lines, setLines] = React.useState([]);
  const [arrow, setArrow] = React.useState([]);
  const [rectangle, setRectangle] = React.useState([]);
  const [science, setScience] = React.useState([]);
  const [folder, setFolder] = React.useState([]);
  const [cards, setCards] = React.useState([]);
  const [table, setTable] = React.useState([]);
  const [square, setSquare] = React.useState([]);
  const [mapBuildings, setmapBuildings] = React.useState([]);
  const [mapImage, setmapImage] = React.useState([]);
  const [mapRoads, setmapRoads] = React.useState([]);
  const [imageCopy, setImageCopy] = React.useState();
  const [title, setTitle] = React.useState([]);
  const [bubbles, setBubbles] = React.useState([]);
  const [notes, setNotes] = React.useState([]);
  const [primer, setPrimer] = React.useState([]);
  // const [sentence, setSentence] = React.useState([]);
  const [structure, setStructure] = React.useState([]);
  const [multiple, setMultiple] = React.useState([]);
  const [matching, setMatching] = React.useState([]);
  const [grouping, setGrouping] = React.useState([]);
  const [passage, setPassage] = React.useState([]);
  const [multipleChoice, setMultipleChoice] = React.useState([]);
  const [matchingChoice, setMatchingChoice] = React.useState([]);
  const [structureChoice, setStructureChoice] = React.useState([]);
  const [alphabet, setAlphabet] = React.useState('');
  const [alpha, setAlpha] = React.useState('');
  const [optionsChart, setOptionsChart] = useState('pie');
  const [Label, setLabel] = useState([]);
  const [labelValue, setLabelValue] = useState([]);
  const [singleLabel, setSingleLabel] = useState([]);
  const [singleLabelValue, setSingleLabelValue] = useState([]);
  const [labelPieValue, setLabelPieValue] = useState([]);
  const [LabelValue1, setLabelValue1] = useState([]);
  const [dataColour, setDataColour] = useState([]);
  const [primerData, setPrimerData] = useState([]);
  const [primerImage, setPrimerImage] = useState([]);
  const [val, setVal] = useState(0);
  const [guides, setGuides] = useState([]);
  const [divided, setDivided] = useState();
  const [recipient, setRecipient] = useState('');
  const [view, setView] = useState(0);
  const [email, setEmail] = useState('');
  const [edit, setEdit] = useState('');
  const [validated, setValidated] = useState("");
  const currentEmail = localStorage.getItem('data');
  // const [selectedOption, setSelectedOption] = useState('edit');

  const GUIDELINE_OFFSET = 5;

  const getLineGuideStops = (skipShape) => {
    // we can snap to stage borders and the center of the stage
    var vertical = [0, stageRef.current.width() / 2, stageRef.current.width()];
    var horizontal = [0, stageRef.current.height() / 2, stageRef.current.height()];

    // and we snap over edges and center of each object on the canvas
    stageRef.current.find(".rectangle").forEach((guideItem) => {
      if (guideItem === skipShape) {
        return;
      }
      var box = guideItem.getClientRect();
      // and we can snap to all edges of shapes
      vertical.push([box.x, box.x + box.width, box.x + box.width / 2]);
      horizontal.push([box.y, box.y + box.height, box.y + box.height / 2]);
    });
    return {
      vertical: vertical.flat(),
      horizontal: horizontal.flat()
    };
  };

  const getObjectSnappingEdges = (node) => {
    var box = node.getClientRect();
    var absPos = node.absolutePosition();

    return {
      vertical: [
        {
          guide: Math.round(box.x),
          offset: Math.round(absPos.x - box.x),
          snap: "start"
        },
        {
          guide: Math.round(box.x + box.width / 2),
          offset: Math.round(absPos.x - box.x - box.width / 2),
          snap: "center"
        },
        {
          guide: Math.round(box.x + box.width),
          offset: Math.round(absPos.x - box.x - box.width),
          snap: "end"
        }
      ],
      horizontal: [
        {
          guide: Math.round(box.y),
          offset: Math.round(absPos.y - box.y),
          snap: "start"
        },
        {
          guide: Math.round(box.y + box.height / 2),
          offset: Math.round(absPos.y - box.y - box.height / 2),
          snap: "center"
        },
        {
          guide: Math.round(box.y + box.height),
          offset: Math.round(absPos.y - box.y - box.height),
          snap: "end"
        }
      ]
    };
  };

  const getGuides = (lineGuideStops, itemBounds) => {
    var resultV = [];
    var resultH = [];

    lineGuideStops.vertical.forEach((lineGuide) => {
      itemBounds.vertical.forEach((itemBound) => {
        var diff = Math.abs(lineGuide - itemBound.guide);
        // if the distance between guild line and object snap point is close we can consider this for snapping
        if (diff < GUIDELINE_OFFSET) {
          resultV.push({
            lineGuide: lineGuide,
            diff: diff,
            snap: itemBound.snap,
            offset: itemBound.offset
          });
        }
      });
    });

    lineGuideStops.horizontal.forEach((lineGuide) => {
      itemBounds.horizontal.forEach((itemBound) => {
        var diff = Math.abs(lineGuide - itemBound.guide);
        if (diff < GUIDELINE_OFFSET) {
          resultH.push({
            lineGuide: lineGuide,
            diff: diff,
            snap: itemBound.snap,
            offset: itemBound.offset
          });
        }
      });
    });

    var guides = [];

    // find closest snap
    var minV = resultV.sort((a, b) => a.diff - b.diff)[0];
    var minH = resultH.sort((a, b) => a.diff - b.diff)[0];
    if (minV) {
      guides.push({
        lineGuide: minV.lineGuide,
        offset: minV.offset,
        orientation: "V",
        snap: minV.snap
      });
    }
    if (minH) {
      guides.push({
        lineGuide: minH.lineGuide,
        offset: minH.offset,
        orientation: "H",
        snap: minH.snap
      });
    }
    return guides;
  };

  const drawGuides = (guides) => {
    if (guides) {
      guides.forEach((lg) => {
        if (lg.orientation === "H") {
          let guide = {
            points: [-6000, 0, 6000, 0],
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            name: "guid-line",
            dash: [4, 6],
            x: 0,
            y: lg.lineGuide
          };
          setGuides([...guides, guide]);
        } else if (lg.orientation === "V") {
          let guide = {
            points: [0, -6000, 0, 6000],
            stroke: "rgb(0, 161, 255)",
            strokeWidth: 1,
            name: "guid-line",
            dash: [4, 6],
            x: lg.lineGuide,
            y: 0
          };
          setGuides([...guides, guide]);
        }
      });
    }
  };

  const onDragMove = (e) => {
    // clear all previous lines on the screen
    // layer.find('.guid-line').destroy();

    // find possible snapping lines
    var lineGuideStops = getLineGuideStops(e.target);
    // find snapping points of current object
    var itemBounds = getObjectSnappingEdges(e.target);

    // now find where can we snap current object
    var guides = getGuides(lineGuideStops, itemBounds);

    // do nothing of no snapping
    if (!guides.length) {
      return;
    }

    drawGuides(guides);

    var absPos = e.target.absolutePosition();
    // now force object position
    guides.forEach((lg) => {
      switch (lg.snap) {
        case "start": {
          switch (lg.orientation) {
            case "V": {
              absPos.x = lg.lineGuide + lg.offset;
              break;
            }
            case "H": {
              absPos.y = lg.lineGuide + lg.offset;
              break;
            }
            default:
              break;
          }
          break;
        }
        case "center": {
          switch (lg.orientation) {
            case "V": {
              absPos.x = lg.lineGuide + lg.offset;
              break;
            }
            case "H": {
              absPos.y = lg.lineGuide + lg.offset;
              break;
            }
            default:
              break;
          }
          break;
        }
        case "end": {
          switch (lg.orientation) {
            case "V": {
              absPos.x = lg.lineGuide + lg.offset;
              break;
            }
            case "H": {
              absPos.y = lg.lineGuide + lg.offset;
              break;
            }
            default:
              break;
          }
          break;
        }
        default:
          break;
      }
    });
    e.target.absolutePosition(absPos);
  };

  const onDragEnd = (e) => {
    setGuides([]);
  };

  // end

  const RedoDoc = () => {
    for (let i = 0; i < layerRef.current.children.length; i++) {
      if (redo.includes(layerRef.current.children[i].attrs.hash)) {
        layerRef.current.children[i].destroy();
      }
    }
  }

  const undoDoc = () => {
    let page2 = DeleteUndo[0]
    if (page2.imageUrl) {
      let line = new Konva.Image(page2);
      const item = {
        ...itemRef.current,
        x: page2.x,
        y: page2.y,
        src: page2.imageUrl,
        scaleX: page2.scaleX,
        scaleY: page2.scaleY,
        type: page2.type,
        hash: page2.hash,
      };
      console.log(page2);
      setImages((image) => [...image, item])
      const redoDelete = DeleteUndo.shift();

      console.log(redoDelete.hash);
      setRedo((current) => [...current, redoDelete.hash])
    } else if (page2.text) {
      const hash = btoa(Math.random()).substr(10, 5);
      const item = {
        ...itemRef.current,
        hash,
        x: page2.x,
        y: page2.y,
        text: page2.text,
        scaleX: page2.scaleX,
        scaleY: page2.scaleY,
        type: page2.type
      };
      setTexts((text) => [...text, item]);
      DeleteUndo.shift();
    } else {
      let line = new Konva.Rect(page2);
      layerRef.current.add(line)
      DeleteUndo.shift();
    }
  }

  const edit1 = (data) => {
    setbol(!bol)
    setflag(data)
  }

  const editsubmit1 = (uri) => {
    const link = document.createElement("a");
    link.href = uri;
    document.body.appendChild(link);
    const newState = images.map(obj => {
      const scalex = activeRef.current.attrs.scaleX
      const scaley = activeRef.current.attrs.scaleY
      // 👇️ if id equals 2, update country property
      if (obj.hash === flag) {
        return { ...obj, src: link.href, scaleX: scalex, scaleY: scaley };
      }

      // 👇️ otherwise return object as is
      return obj;
    });

    setImages(newState);
    setflag(null)
    setbol(false)
    document.body.removeChild(link);
  }

  //image upload
  const handleChange = (event) => {
    setFile(event.target.files[0])
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const url = `${apiUrl}img`;
    const formData = new FormData();
    formData.append('img', file);
    formData.append('img', file.name);
    const config = {
      headers: {
        'content-type': 'multipart/form-data', 'Accept': 'application/json, text/plain, */*',
      }
    };
    axios.post(url, formData).then((response) => {
      // setImg(current => [...current, response.data.result]);
    }).catch((error) => console.log(error.response.data));
  }

  useEffect(() => {
    axios.get(`${apiUrl}img`).then((res) => {
      setImg(res.data)
    })
      .catch(err => err)
  }, [])

  useEffect(() => {
    window.addEventListener("keydown", function (e) {
      if (e.keyCode === 46 && activeRef.current && layerRef.current) {
        setSelectedId(null);
        setDeleteUndo((current) => [...current, activeRef.current.attrs])
        activeRef.current.destroy();
        layerRef.current.draw();
        setImageEdit(false);
        setTextEdit(false);
        setdiagram(0);
      }
      if (e.keyCode === 82) {
        setSelectedId(null);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`${apiUrl}template`).then((res) => {
      for (let i = 0; i < res.data.length; i++) {
        for (let j = 0; j < res.data[i].data.length; j++) {
          setTemplateData((current) => [...current, res.data[i].data[j]])
        }
        setTemplateImage((current) => [...current, res.data[i]])
      }
    })

    axios.get(`${apiLocal}group`).then((res) => {
      for (let i = 0; i < res.data.length; i++) {
        for (let j = 0; j < res.data[i].data.length; j++) {
          setPrimerData((current) => [...current, res.data[i].data[j]])
        }
        setPrimerImage((current) => [...current, res.data[i]])
      }
    })
  }, [])
  // Api Call for template
  useEffect(() => {
    fetchData();
  }, [])
                                                                                                                                                                                                                                                                                                                                                                                                                                                     
  const fetchData = useCallback(() => {
    axios.get(`${apiShapes}`).then((res) => {
      for (let i = 0; i < res.data.length; i++) {
        for (let j = 0; j < res.data[i].length; j++) {
          if (res.data[i][j] === 'lines') {
            setLines(res.data[i][1]);
          }
          if (res.data[i][j] === 'arrow') {
            setArrow(res.data[i][1]);
          }
          if (res.data[i][j] === 'rectangle') {
            setRectangle(res.data[i][1]);
          }
          //  if (res.data[i][j] === 'sentence') {
          //   setSentence (res.data[i][1]);
          // }
          if (res.data[i][j] === 'square') {
            setSquare(res.data[i][1]);
          }
          if (res.data[i][j] === 'map-image') {
            setmapImage(res.data[i][1]);
          }
          if (res.data[i][j] === 'map-building') {
            setmapBuildings(res.data[i][1]);
          }
          if (res.data[i][j] === 'map-road') {
            setmapRoads(res.data[i][1]);
          }
          if (res.data[i][j] === 'title') {
            setTitle(res.data[i][1]);
          }
          if (res.data[i][j] === 'notes') {
            setNotes(res.data[i][1]);
          }
          if (res.data[i][j] === 'bubbles') {
            setBubbles(res.data[i][1]);
          }
          if (res.data[i][j] === 'primer') {
            setPrimer(res.data[i][1]);
          }
          if (res.data[i][j] === 'matching') {
            setMatching(res.data[i][1]);
          }
          if (res.data[i][j] === 'structure') {
            setStructure(res.data[i][1]);
          }
          if (res.data[i][j] === 'multiple') {
            setMultiple(res.data[i][1]);
          }
          if (res.data[i][j] === 'grouping') {
            setGrouping(res.data[i][1]);
          }
          if (res.data[i][j] === 'passage') {
            setPassage(res.data[i][1]);
          }
          if (res.data[i][j] === 'matchingChoice') {
            setMatchingChoice(res.data[i][1]);
          }
          if (res.data[i][j] === 'structureChoice') {
            setStructureChoice(res.data[i][1]);
          }
          if (res.data[i][j] === 'multipleChoice') {
            setMultipleChoice(res.data[i][1]);
          }
          if (res.data[i][j] === 'science') {
            setScience(res.data[i][1]);
          }
          if (res.data[i][j] === 'table') {
            setTable(res.data[i][1]);
          }
          if (res.data[i][j] === 'cards') {
            setCards(res.data[i][1]);
          }
          if (res.data[i][j] === 'folder') {
            setFolder(res.data[i][1]);
          }
        }
      }
    })
  }, []);

  useEffect(() => {
    if (recentPages.state) {
      setPage1(recentPages.state.item.data)
      setData(recentPages.state.item.img)
      if(recentPages.state.item.edit.includes(currentEmail)){
        setView(2)
      }
      else if(recentPages.state.item.viewed.includes(currentEmail)){
        setView(1)
      }
    }
  }, [])


  const template = (index) => {
    let page2 = templateData[index]
    const count = layerRef.current.children.length;
    for (let i = 0; i <= count; i++) {
      layerRef.current.children.pop(0, count);
    }
    for (let i = 0; i < page2.length; i++) {
      if (page2[i].imageUrl) {
        let line = new Konva.Image(page2[i]);
        const hash = btoa(Math.random()).substr(10, 5);
        const item = {
          ...itemRef.current,
          hash,
          x: page2[i].x,
          y: page2[i].y,
          src: page2[i].imageUrl,
          scaleX: page2[i].scaleX,
          scaleY: page2[i].scaleY,
          type: page2[i].type
        };
        setImages((image) => [...image, item])
      } else if (page2[i].text) {
        const hash = btoa(Math.random()).substr(10, 5);
        const item = {
          ...itemRef.current,
          hash,
          x: page2[i].x,
          y: page2[i].y,
          text: page2[i].text,
          scaleX: page2[i].scaleX,
          scaleY: page2[i].scaleY,
          type: page2[i].type
        };
        setTexts((text) => [...text, item]);
      } else {
        let line = new Konva.Rect(page2[i]);
        layerRef.current.add(line)
      }
    }
  }

  const primerTemplate = (index) => {
    let page2 = primerData[index]
    for (let i = 0; i < page2.length; i++) {
      if (page2[i].imageUrl) {
        let line = new Konva.Image(page2[i]);
        const hash = btoa(Math.random()).substr(10, 5);
        const item = {
          ...itemRef.current,
          hash,
          x: page2[i].x,
          y: page2[i].y,
          src: page2[i].imageUrl,
          scaleX: page2[i].scaleX,
          scaleY: page2[i].scaleY,
          type: page2[i].type
        };
        setImages((image) => [...image, item])
      } else if (page2[i].text) {
        const hash = btoa(Math.random()).substr(10, 5);
        const item = {
          ...itemRef.current,
          hash,
          x: page2[i].x,
          y: page2[i].y,
          text: page2[i].text,
          scaleX: page2[i].scaleX,
          scaleY: page2[i].scaleY,
          type: page2[i].type
        };
        setTexts((text) => [...text, item]);
      } else {
        let line = new Konva.Rect(page2[i]);
        layerRef.current.add(line)
      }
    }
  }

  const buttonfor = () => {
    const info = ({ data: page1, img: data })
    axios.post(`${apiUrl}template`, info).then((res) => {
      console.log(res.data)
    })
  }

  const btnPost = () => {
    const info = ({ data: page1 })
    axios.post(`${apiLocal}group`, info).then((res) => {
      console.log(res.data)
    })
  }

  const Recent = () => {
    if (recentPages.state) {
      const _id = recentPages.state.item._id
      const info = ({ id: _id, data: page1, img: data })
      axios.put(`${apiLocal}recent`, info).then((res) => {
      })
      toast({
        title: 'successfully updated',
        status: 'success',
        isClosable: true,
      })
      setPage1([]);
    } else {
      const email = localStorage.getItem('data');
      const info = ({ email: email, data: page1, img: data })
      axios.post(`${apiLocal}recent`, info).then((res) => {
      })
      toast({
        title:'successfully saved',
        status: 'success',
        isClosable: true,
      })
      setPage1([]);
    }
  }
// var temp_html="";
      for(let k=0;k<25;k++){
      var inp1 = document.createElement("input");
          inp1.setAttribute("value",k);
          inp1.classList.add("inp_class");
          inp1.setAttribute("onKeyPress",(e)=>enter_val(this));         
          console.log(inp1); 
          console.log(document.getElementById("alter")); 
          // document.getElementById("alter").appendChild(inp1);  
          // temp_html+=inp1;
      }
      // document.getElementById("alter").innerHTML=temp_html;
  // function remo_ve(){
  //   let inp_bord = document.getElementsByClassName("inp_class");
  //   for(let l=0;l<inp_bord.length;l++){
  //       inp_bord[l].style.border="none";
  //   }
  // }

  //addition
  const [boxCount, setBoxCount] = useState(6);
  const [pushedArray, setPushedArray] = useState([]);

  const generateBoxes = () => {
    let arr = [];
    for (let i = 0; i < boxCount; i++) {
      for (let j = 0; j < boxCount; j++) {
        arr.push(`${i} ${j}`);
      }
    }
    setPushedArray(arr);
  };

  const handleKeyDown = (event) => {
    const { keyCode } = event;
    const val = event.target;

    if (keyCode === 37 && val.style.borderLeft === "none") {
      val.style.borderLeft = "1px solid red";
    } else if (keyCode === 37 && val.style.borderLeft !== "none") {
      val.style.borderLeft = "none";
    }

    if (keyCode === 38 && val.style.borderTop === "none") {
      val.style.borderTop = "1px solid red";
    } else if (keyCode === 38 && val.style.borderTop !== "none") {
      val.style.borderTop = "none";
    }

    if (keyCode === 39 && val.style.borderRight === "none") {
      val.style.borderRight = "1px solid red";
    } else if (keyCode === 39 && val.style.borderRight !== "none") {
      val.style.borderRight = "none";
    }

    if (keyCode === 40 && val.style.borderBottom === "none") {
      val.style.borderBottom = "1px solid red";
    } else if (keyCode === 40 && val.style.borderBottom !== "none") {
      val.style.borderBottom = "none";
    }
  };

  const handleRemove = () => {
    const inputs = document.getElementsByClassName("inp_class");
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].style.border = "none";
    }
  };
  useEffect(()=>{
    generateBoxes()
  },[])

   const  enter_val=(val,event)=>{
        
          if(event.keyCode == 37 && val.style.borderLeft=="none"){
          val.style.borderLeft="1px solid red";
          console.log(event.keyCode);
          }
          else{
              if(event.keyCode === 37 && val.style.borderLeft!="none"){
                      val.style.borderLeft="none";
              }
          }
          // TOP
          if(event.keyCode == 38 && val.style.borderTop=="none"){
          val.style.borderTop="1px solid red";
          console.log(event.keyCode);
          }
          else{
              if(event.keyCode == 38 && val.style.borderTop!="none"){
                      val.style.borderTop="none";
              }
          }
          // RIGHT
          if(event.keyCode == 39 && val.style.borderRight=="none"){
          val.style.borderRight="1px solid red";
          console.log(event.keyCode);
          }
          else{
              if(event.keyCode == 39 && val.style.borderRight!="none"){
                      val.style.borderRight="none";
              }
          }
          // BOTTOM
          if(event.keyCode == 40 && val.style.borderBottom=="none"){
          val.style.borderBottom="1px solid red";
          console.log(event.keyCode);
          }
          else{
              if(event.keyCode == 40 && val.style.borderBottom!="none"){
                      val.style.borderBottom="none";
              }
          }
        
   }

  //single image download
  const downloadURI = (uri) => {
    const link = document.createElement("a");
    link.download = 'image.jpeg';
    link.href = uri;
    document.body.appendChild(link);
    setData(current => [...current, link.href]);
    document.body.removeChild(link);
  };

  //fonts color text start
  useEffect(() => {
    // changing of reference
    if (activeRef.current) {
      const { fontSize, fontFamily, scaleX, scaleY, lineHeight, letterSpacing, textDecoration, fontStyle, align } = activeRef.current.attrs;
      setFont({
        size: fontSize,
        family: fontFamily,
        letterSpacing: letterSpacing,
        lineHeight: lineHeight,
        align: align,
        textDecoration: textDecoration,
        fontStyle: fontStyle
      });
      setscale({
        scaleX: scaleX,
        scaleY: scaleY
      });
    }
  }, [selectedId]);


  useEffect(() => {
    const { scaleX, scaleY } = scale;
    if (activeRef.current) {
      activeRef.current.attrs.scaleX = scaleX;
      activeRef.current.attrs.scaleY = scaleY;
    }
  }, [scale]);

  useEffect(() => {
    const { size, family, lineHeight, letterSpacing, fontStyle, textDecoration, align } = font;
    if (activeRef.current) {
      activeRef.current.attrs.fontSize = size;
      activeRef.current.attrs.fontFamily = family;
      activeRef.current.attrs.letterSpacing = parseInt(letterSpacing);
      activeRef.current.attrs.lineHeight = lineHeight;
      activeRef.current.attrs.fontStyle = fontStyle;
      activeRef.current.attrs.textDecoration = textDecoration;
      activeRef.current.attrs.align = align;
    }
  }, [font]);//font

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.attrs.fill = color;
    }
  }, [color])
  //font color text end

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "its will clear";
      return "its wll clear";
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, []);
  //alert for reload

  useEffect(() => {
    window.addEventListener("keydown", function (e) {
      e = e || window.event;  // Event object 'ev'
      var key = e.which || e.keyCode;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17)
        ? true : false);

      //right
      if (e.keyCode === 39 && ctrl && activeRef.current && layerRef.current) {
        const img = activeRef.current.attrs.imageUrl
        const x = activeRef.current.attrs.x
        const scaleX = activeRef.current.attrs.scaleX
        const y = activeRef.current.attrs.y
        const scaleY = activeRef.current.attrs.scaleY
        const txt = activeRef.current.attrs.text
        const hash = btoa(Math.random()).substr(10, 5);
        // register event position

        const item = {
          ...itemRef.current.src = img,
          ...itemRef.current.scaleX = scaleX,
          ...itemRef.current.scaleY = scaleY,
          ...itemRef.current.y = y,
          ...itemRef.current.x = x + (scaleX * 71),
          ...itemRef.current,
          hash,
        };
        setImages((images) => [...images, item]);
      }
      //down
      if (e.which === 40 && ctrl && activeRef.current && layerRef.current) {
        const img = activeRef.current.attrs.imageUrl
        const x = activeRef.current.attrs.x
        const scaleX = activeRef.current.attrs.scaleX
        const y = activeRef.current.attrs.y
        const scaleY = activeRef.current.attrs.scaleY
        const txt = activeRef.current.attrs.text
        const hash = btoa(Math.random()).substr(10, 5);
        // register event position
        const item = {
          ...itemRef.current.src = img,
          ...itemRef.current.x = x,
          ...itemRef.current.scaleX = scaleX,
          ...itemRef.current.scaleY = scaleY,
          ...itemRef.current.y = y + (scaleY * 50),
          ...itemRef.current,
          hash,
        };
        setImages((images) => [...images, item]);
      }
      //left
      if (e.which === 37 && ctrl && activeRef.current && layerRef.current) {
        const img = activeRef.current.attrs.imageUrl
        const x = activeRef.current.attrs.x
        const scaleX = activeRef.current.attrs.scaleX
        const y = activeRef.current.attrs.y
        const scaleY = activeRef.current.attrs.scaleY
        const txt = activeRef.current.attrs.text
        const hash = btoa(Math.random()).substr(10, 5);
        // register event position
        const item = {
          ...itemRef.current.src = img,
          ...itemRef.current.x = x - (scaleX * 71),
          ...itemRef.current.scaleX = scaleX,
          ...itemRef.current.scaleY = scaleY,
          ...itemRef.current.y = y,
          ...itemRef.current,
          hash,
        };
        setImages((images) => [...images, item]);
      }
      //up
      if (e.which === 38 && ctrl && activeRef.current && layerRef.current) {
        const img = activeRef.current.attrs.imageUrl
        const x = activeRef.current.attrs.x
        const scaleX = activeRef.current.attrs.scaleX
        const y = activeRef.current.attrs.y
        const scaleY = activeRef.current.attrs.scaleY
        const txt = activeRef.current.attrs.text
        const hash = btoa(Math.random()).substr(10, 5);
        // register event position
        const item = {
          ...itemRef.current.src = img,
          ...itemRef.current.x = x,
          ...itemRef.current.scaleX = scaleX,
          ...itemRef.current.scaleY = scaleY,
          ...itemRef.current.y = y - (scaleY * 50),
          ...itemRef.current,
          hash,
        };
        setImages((images) => [...images, item]);

      }
    });
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", function (e) {
      e = e || window.event;  // Event object 'ev'
      var key = e.which || e.keyCode;
      var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17)
        ? true : false);

      if (e.keyCode === 67 && ctrl && activeRef.current && layerRef.current) {
        const hash = btoa(Math.random()).substr(10, 5);
        // register event position
        if(trRef.current._nodes){
            const groupImageCopy=[]
            const groupTextCopy=[]
            for(let i=0;i<trRef.current._nodes.length;i++){
              const item = {
                ...itemRef.current.src = trRef.current._nodes[i].attrs.imageUrl,
                ...itemRef.current.x = trRef.current._nodes[i].attrs.x+180,
                ...itemRef.current.scaleX = trRef.current._nodes[i].attrs.scaleX,
                ...itemRef.current.scaleY = trRef.current._nodes[i].attrs.scaleY,
                ...itemRef.current.y = trRef.current._nodes[i].attrs.y,
                ...itemRef.current,
                hash,
              };
              groupImageCopy.push(item)
              // if(trRef.current._nodes[i].attrs.text){
              //   const item = {
              //     ...itemRef.current=trRef.current._nodes[i].attrs,
              //     // ...itemRef.current.text = trRef.current._nodes[i].attrs.text,
              //     // ...itemRef.current.fontSize = trRef.current._nodes[i].attrs.fontSize,
              //     // ...itemRef.current.x = trRef.current._nodes[i].attrs.x+100,
              //     // ...itemRef.current.scaleX = trRef.current._nodes[i].attrs.scaleX,
              //     // ...itemRef.current.scaleY = trRef.current._nodes[i].attrs.scaleY,
              //     // ...itemRef.current.y = trRef.current._nodes[i].attrs.y,
              //     // ...itemRef.current.fontStyle = trRef.current._nodes[i].attrs.fontStyle,
              //     // ...itemRef.current.fontFamily = trRef.current._nodes[i].attrs.fontFamily,
              //     // ...itemRef.current.align = trRef.current._nodes[i].attrs.align,
              //     // ...itemRef.current.letterSpacing = trRef.current._nodes[i].attrs.letterSpacing,
              //     // ...itemRef.current.lineHeight = trRef.current._nodes[i].attrs.lineHeight,
              //     // ...itemRef.current.height = trRef.current._nodes[i].attrs.height,
              //     ...itemRef.current,
              //     hash,
              //   };
              //   console.log(item);
              //   groupTextCopy.push(item)
              // }else{
              //   const item = {
              //     ...itemRef.current.src = trRef.current._nodes[i].attrs.imageUrl,
              //     ...itemRef.current.x = trRef.current._nodes[i].attrs.x+180,
              //     ...itemRef.current.scaleX = trRef.current._nodes[i].attrs.scaleX,
              //     ...itemRef.current.scaleY = trRef.current._nodes[i].attrs.scaleY,
              //     ...itemRef.current.y = trRef.current._nodes[i].attrs.y,
              //     ...itemRef.current,
              //     hash,
              //   };
              //   groupImageCopy.push(item)
              // }
             
            }
            groupImageCopy.forEach(element=>{
              setImages((images) => [...images, element]);
            })
            // groupTextCopy.forEach(element=>{
            //   setTexts((text) => [...text, element]);
            // })          
        }
      }
      if (e.keyCode === 68  && activeRef.current && layerRef.current) {
        console.log(activeRef.current)
        const hash = btoa(Math.random()).substr(10, 5);
        // register event position
        if(trRef.current._nodes){
            const groupImageCopy=[]
            const groupTextCopy=[]
            for(let i=0;i<trRef.current._nodes.length;i++){
              const item = {
                ...itemRef.current.src = trRef.current._nodes[i].attrs.imageUrl,
                ...itemRef.current.x = trRef.current._nodes[i].attrs.x,
                ...itemRef.current.scaleX = trRef.current._nodes[i].attrs.scaleX,
                ...itemRef.current.scaleY = trRef.current._nodes[i].attrs.scaleY,
                ...itemRef.current.y = trRef.current._nodes[i].attrs.y+100,
                ...itemRef.current,
                hash,
              };
              groupImageCopy.push(item)
              // if(trRef.current._nodes[i].attrs.text){
              //   const item = {
              //     ...itemRef.current=trRef.current._nodes[i].attrs,
              //     // ...itemRef.current.text = trRef.current._nodes[i].attrs.text,
              //     // ...itemRef.current.fontSize = trRef.current._nodes[i].attrs.fontSize,
              //     // ...itemRef.current.x = trRef.current._nodes[i].attrs.x+100,
              //     // ...itemRef.current.scaleX = trRef.current._nodes[i].attrs.scaleX,
              //     // ...itemRef.current.scaleY = trRef.current._nodes[i].attrs.scaleY,
              //     // ...itemRef.current.y = trRef.current._nodes[i].attrs.y,
              //     // ...itemRef.current.fontStyle = trRef.current._nodes[i].attrs.fontStyle,
              //     // ...itemRef.current.fontFamily = trRef.current._nodes[i].attrs.fontFamily,
              //     // ...itemRef.current.align = trRef.current._nodes[i].attrs.align,
              //     // ...itemRef.current.letterSpacing = trRef.current._nodes[i].attrs.letterSpacing,
              //     // ...itemRef.current.lineHeight = trRef.current._nodes[i].attrs.lineHeight,
              //     // ...itemRef.current.height = trRef.current._nodes[i].attrs.height,
              //     ...itemRef.current,
              //     hash,
              //   };
              //   console.log(item);
              //   groupTextCopy.push(item)
              // }else{
              //   const item = {
              //     ...itemRef.current.src = trRef.current._nodes[i].attrs.imageUrl,
              //     ...itemRef.current.x = trRef.current._nodes[i].attrs.x+180,
              //     ...itemRef.current.scaleX = trRef.current._nodes[i].attrs.scaleX,
              //     ...itemRef.current.scaleY = trRef.current._nodes[i].attrs.scaleY,
              //     ...itemRef.current.y = trRef.current._nodes[i].attrs.y,
              //     ...itemRef.current,
              //     hash,
              //   };
              //   groupImageCopy.push(item)
              // }
            }
            groupImageCopy.forEach(element=>{
              setImages((images) => [...images, element]);
            })
            // groupTextCopy.forEach(element=>{
            //   setTexts((text) => [...text, element]);
            // })          
        }
      }
      if (e.keyCode === 90 && ctrl) {
        undoDoc();
      }
    });
  }, []);
 
  const generatepdf = (event) => {
    event.preventDefault()
    var imageQuality = 1;
    var dpi = 300; 
var options = {
  dpi: dpi
};
    const doc = new jsPDF(options);
   
    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();
    for (let i = 0; i < data.length; i++) {
      doc.addImage(data[i], 'JPEG', 0, 0, width, height,imageQuality);
      doc.addPage();
      doc.deletePage((data.length) + 1)
    }
    doc.save("question_paper.pdf");
    setData([])
  }
  //pdf

  const underline = () => {
    if (font.textDecoration === "") {
      setFont({ ...font, textDecoration: "underline" })
    } else {
      setFont({ ...font, textDecoration: "" })
    }
  };

  const italic = () => {
    if (font.fontStyle === "italic") {
      setFont({ ...font, fontStyle: "" })
    } else if (font.fontStyle === "bold") {
      setFont({ ...font, fontStyle: "italic" })
    } else {
      setFont({ ...font, fontStyle: "italic" })
    }
  }

  const bold = () => {
    if (font.fontStyle === "bold") {
      setFont({ ...font, fontStyle: "" })
    } else if (font.fontStyle === "italic") {
      setFont({ ...font, fontStyle: "bold" })
    } else {
      setFont({ ...font, fontStyle: "bold" })
    }
  }

  const demoDisplay = (e) => {
    const val = e.target.value
    var main = document.getElementById("main");
    main.innerHTML = "";
    for (var i = 0; i < val; i++) {
      var box = document.createElement("div");
      box.classList.add("square");
      main.append(box);
    }
  }

  const Paste = () => {
    const img = activeRef.current.attrs.imageUrl
    const x = activeRef.current.attrs.x
    const scaleX = activeRef.current.attrs.scaleX
    const y = activeRef.current.attrs.y
    const scaleY = activeRef.current.attrs.scaleY
    const txt = activeRef.current.attrs.text
    const hash = btoa(Math.random()).substr(10, 5);
    // register event position

    if (activeRef.current.attrs.imageUrl) {
      const item = {
        ...itemRef.current, src: img, x: x + (scaleX * 100), scaleX: scaleX, scaleY: scaleY, y: y, hash
      };
      setImages((images) => [...images, item]);

    } else {
      const text = {
        ...itemRef.current,
        text: txt,
        x: x + (scaleX * 100),
        y: y,
        hash,
      };
      setTexts((texts) => [...texts, text]);
    }
  }

  const Cut = () => {
    const img = activeRef.current.attrs.imageUrl
    const x = activeRef.current.attrs.x
    const scaleX = activeRef.current.attrs.scaleX
    const y = activeRef.current.attrs.y
    const scaleY = activeRef.current.attrs.scaleY
    const txt = activeRef.current.attrs.text
    const hash = btoa(Math.random()).substr(10, 5);
    // register event position

    const item1 = {
      src: img, x: x, scaleX: scaleX, scaleY: scaleY, y: y, hash
    }
    setImageCopy(item1)
    // setSelectedId(null)
    activeRef.current.destroy();
  }

  const Copy = () => {
    const img = activeRef.current.attrs.imageUrl
    const x = activeRef.current.attrs.x
    const scaleX = activeRef.current.attrs.scaleX
    const y = activeRef.current.attrs.y
    const scaleY = activeRef.current.attrs.scaleY
    const txt = activeRef.current.attrs.text
    const hash = btoa(Math.random()).substr(10, 5);
    // register event position

    const item1 = {
      src: img, x: x + (scaleX * 100), scaleX: scaleX, scaleY: scaleY, y: y, hash
    }
    setImageCopy(item1)
  }

  // For abacus
  const displayabacus = () => {
    const val1 = document.getElementById("txt6").value
    const val2 = document.getElementById("txt2").value
    const val3 = document.getElementById("txt3").value
    const val4 = document.getElementById("txt4").value
    const val5 = document.getElementById("txt5").value
    const val7 = document.getElementById("txt7").value

    let main1 = document.getElementById('row1');
    main1.innerHTML = '';
    for (let i = 0; i < val1; i++) {
      const bee = document.createElement('td');
      bee.classList.add('column')
      main1.append(bee);
    }

    let main2 = document.getElementById('row2');
    main2.innerHTML = '';
    for (let i = 0; i < val2; i++) {
      const bee = document.createElement('td');
      bee.classList.add('column')
      main2.append(bee);
    }
    let main3 = document.getElementById('row3');
    main3.innerHTML = '';
    for (let i = 0; i < val3; i++) {
      const bee = document.createElement('td');
      bee.classList.add('column')
      main3.append(bee);
    }
    let main4 = document.getElementById('row4');
    main4.innerHTML = '';
    for (let i = 0; i < val4; i++) {
      const bee = document.createElement('td');
      bee.classList.add('column')
      main4.append(bee);
    }
    let main5 = document.getElementById('row5');
    main5.innerHTML = '';
    for (let i = 0; i < val5; i++) {
      const bee = document.createElement('td');
      bee.classList.add('column')
      main5.append(bee);
    }
    let main7 = document.getElementById('row6');
    main7.innerHTML = '';
    for (let i = 0; i < val7; i++) {
      const bee = document.createElement('td');
      bee.classList.add('column')
      main7.append(bee);
    }
  }

  useEffect(() => {
    let ctx = document.getElementById('chart');
    var pieChart;
    pieChart = new Chart(ctx, {
      type: optionsChart,
      plugins: [ChartDataLabels],
      data: {
        labels: singleLabel,
        datasets: [
          {
            data: singleLabelValue,
            backgroundColor: 'grey',
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          datalabels: {
            align: 'center',
            font: {
              weight: 'bold',
              size: 18,
            },
            color: 'black'
          }
        }
      }
    });

    return () => {
      pieChart.destroy();
    }
  }, [singleLabelValue, singleLabel, optionsChart]);

  const handleSubmit1 = (e) => {
    e.preventDefault();
    let chart = Label.split(',');
    setSingleLabel(chart)
    let chart2 = labelValue.split(',');
    setSingleLabelValue(chart2)
  };

  // piechart
  useEffect(() => {
    let ctx = document.getElementsByClassName('chart1');
    var pieChart;
    pieChart = new Chart(ctx, {
      type: 'pie',
      data: {
        datasets: [
          {
            data: LabelValue1,
            backgroundColor: dataColour != 0 ? dataColour : 'white',
            borderColor: 'black'
          },
        ],
      },
    });

    return () => {
      pieChart.destroy();
    }
  }, [LabelValue1]);

  const handleSubmitPie = (e) => {
    e.preventDefault();
    let chart3 = labelPieValue.split(',');
    setLabelValue1(chart3)
    let chart2 = dataColour.split(',');
    setDataColour(chart2);
  }

  const toChangeValue = () => {
    const Add1 = document.getElementById('text1').value;
    document.getElementById('num1').innerText = Add1;
    const Add2 = document.getElementById('text2').value;
    document.getElementById('num2').innerText = Add2;
    const Add3 = document.getElementById('text3').value;
    document.getElementById('num3').innerText = Add3;
    const Add4 = document.getElementById('text4').value;
    document.getElementById('num4').innerText = Add4;
    const Add5 = document.getElementById('text5').value;
    document.getElementById('num5').innerText = Add5;
    const Add6 = document.getElementById('text6').value;
    document.getElementById('num6').innerText = Add6;
    const Add7 = document.getElementById('text7').value;
    document.getElementById('num7').innerText = Add7;
  }

  const Division = () => {
    const Add1 = document.getElementById('int').value;
    document.getElementById('txts').innerText = Add1;
    const Add7 = document.getElementById('int6').value;
    document.getElementById('txts1').innerText = Add7;
    const Add2 = document.getElementById('int1').value;
    document.getElementById('txts2').innerText = Add2;
    const Add3 = document.getElementById('int2').value;
    document.getElementById('txts3').innerText = Add3;
    const Add4 = document.getElementById('int3').value;
    document.getElementById('txts4').innerText = Add4;
    const Add5 = document.getElementById('int4').value;
    document.getElementById('txts5').innerText = Add5;
    const Add6 = document.getElementById('int5').value;
    document.getElementById('txts6').innerText = Add6;
    const Add8 = document.getElementById('int7').value;
    document.getElementById('txts7').innerText = Add8;
    const Add9 = document.getElementById('int8').value;
    document.getElementById('txts8').innerText = Add9;
  }

  const select = (val) => {
    const strs = document.getElementsByClassName("str7")
    for (let i = 0; i < strs.length; i++) {
      if (i == val) {
        strs[i].classList.toggle('new');
      }
    }
  }

  let prev_ind = -1;
  const sel = (num) => {
    const strs = document.getElementsByClassName("str0")
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind >= num) {
        strs[i].style.transform = "translateY(0px)";
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind = -1;
    }
    else {
      prev_ind = num;
    }
  }

  let crnt_ind1 = 0;
  let prev_ind1 = -1;
  const sel1 = (num) => {
    const strs = document.getElementsByClassName("str1")
    crnt_ind1 = num;
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind1 >= crnt_ind1) {
        if (prev_ind1 >= i && crnt_ind1 <= i) {
          strs[i].style.transform = "translateY(0px)";
        }
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind1 = -1;
    }
    else {
      prev_ind1 = num;
    }
  }

  let crnt_ind2 = 0;
  let prev_ind2 = -1;
  const sel2 = (num) => {
    const strs = document.getElementsByClassName("str2")
    crnt_ind2 = num;
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind2 >= crnt_ind2) {
        if (prev_ind2 >= i && crnt_ind2 <= i) {
          strs[i].style.transform = "translateY(0px)";
        }
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind2 = -1;
    }
    else {
      prev_ind2 = num;
    }
  }

  let crnt_ind3 = 0;
  let prev_ind3 = -1;
  const sel3 = (num) => {
    console.log(num);
    const strs = document.getElementsByClassName("str3")
    crnt_ind3 = num;
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind3 >= crnt_ind3) {
        if (prev_ind3 >= i && crnt_ind3 <= i) {
          strs[i].style.transform = "translateY(0px)";
        }
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind3 = -1;
    }
    else {
      prev_ind3 = num;
    }
  }

  let crnt_ind4 = 0;
  let prev_ind4 = -1;
  const sel4 = (num) => {
    const strs = document.getElementsByClassName("str4")
    crnt_ind4 = num;
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind4 >= crnt_ind4) {
        if (prev_ind4 >= i && crnt_ind4 <= i) {
          strs[i].style.transform = "translateY(0px)";
        }
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind4 = -1;
    }
    else {
      prev_ind4 = num;
    }
  }

  let crnt_ind5 = 0;
  let prev_ind5 = -1;
  const sel5 = (num) => {
    console.log(num);
    const strs = document.getElementsByClassName("str5")
    crnt_ind5 = num;
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind5 >= crnt_ind5) {
        if (prev_ind5 >= i && crnt_ind5 <= i) {
          strs[i].style.transform = "translateY(0px)";
        }
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind5 = -1;
    }
    else {
      prev_ind5 = num;
    }
  }

  let crnt_ind6 = 0;
  let prev_ind6 = -1;
  const sel6 = (num) => {
    const strs = document.getElementsByClassName("str6")
    crnt_ind6 = num;
    for (let i = 0; i < strs.length; i++) {
      if (prev_ind6 >= crnt_ind6) {
        if (prev_ind6 >= i && crnt_ind6 <= i) {
          strs[i].style.transform = "translateY(0px)";
        }
      }
      else {
        if (num >= i) {
          strs[i].style.transform = "translateY(-22px)";
        }
      }
    }
    if (num == 0) {
      prev_ind6 = -1;
    }
    else {
      prev_ind6 = num;
    }
  }

  const onClickImages = (e) => {
    const hash = btoa(Math.random()).substr(10, 5);
    const item = {
      ...itemRef.current,
      hash,
      x: 140,
      y: 300,
      src: e.target.src,
      scaleX: 1,
      scaleY: 1,
      type: 'image'
    };
    setImages((image) => [...image, item])
  }

  const renderBoxes = () => {
    const boxes = [];
    for (let i = 0; i < val; i++) {
      const row = [];
      for (let j = 0; j < val; j++) {
        row.push(
          <div
            key={`${i}-${j}`}
            className="box_style"
            onClick={(event) => {
              const box = event.target;
              if (box.style.background === "black") {
                box.style.background = "#fff";
                box.style.border = "1px solid black";
              } else {
                box.style.background = "black";
                box.style.border = "1px solid #fff";
              }
            }}
          ></div>
        );
      }
      boxes.push(
        <div key={i} id={`main${i}`}>
          {row}
        </div>
      );
    }
    return boxes;
  };

  const menu1 = (
    <Menu onClick={({ key }) => {
      if (key === "Duplicate") {
        Paste()
        setImageDrop(false)
      }
      if (key === "Delete") {
        setSelectedId(null);
        setDeleteUndo((current) => [...current, activeRef.current.attrs])
        console.log(activeRef.current.attrs);
        setImageEdit(false);
        setTextEdit(false);
        setdiagram(0);
        activeRef.current.destroy();
        setImageDrop(false)
      }
      if (key === "Move Forward") {
        if (activeRef.current) {
          activeRef.current.moveToTop();
          layerRef.current.draw();
          setImageDrop(false)

        }
      }
      if (key === "Move Backward") {
        if (activeRef.current) {
          activeRef.current.moveToBottom();
          // backgroundRef.current.moveToBottom();
          layerRef.current.draw();
          setImageDrop(false)
        }
      }
      if (key === "Copy") {
        Copy();
        setImageDrop(false)
      }
      if (key === "Cut") {
        Cut();
        setImageDrop(false)
      }
      if (key === "Paste") {
        setImages((images) => [...images, imageCopy])
        setImageCopy();
        setImageDrop(false)
      }
    }}
      items={[
        { label: "Duplicate", key: "Duplicate", icon: <ContentCopyIcon style={{ fontSize: '22px' }} /> },
        { label: "Cut", key: "Cut", icon: <ContentCutIcon style={{ fontSize: '22px' }} /> },
        { label: "Copy", key: "Copy", icon: <DifferenceOutlinedIcon style={{ fontSize: '22px' }} /> },
        { label: "Paste", key: "Paste", disabled: imageCopy ? false : true, icon: <ContentPasteOutlinedIcon style={{ fontSize: '22px' }} /> },
        { label: "Delete", key: "Delete", style: { color: 'red' }, icon: <DeleteOutlineIcon style={{ color: 'red', fontSize: '24px' }} /> },
        { label: "Move Forward", key: "Move Forward", icon: <FlipToFrontIcon style={{ fontSize: '22px' }} /> },
        { label: "Move Backward", key: "Move Backward", icon: <FlipToBackIcon style={{ fontSize: '22px' }} /> },
        // {
        //   label: "Line Thickness", key: "Line Thickness", children: [
        //     {
        //       key: '1.0',
        //       label: '1.0',
        //     },
        //     {
        //       key: '1.5',
        //       label: '1.5',
        //     },
        //     {
        //       key: '2.0',
        //       label: '2.0',
        //     },
        //   ],
        // },
        // {
        //   label: "Line Shape", key: "Line Shape", children: [
        //     {
        //       key: 'Normal',
        //       label: 'Normal',
        //     },
        //     {
        //       key: 'Dot',
        //       label: 'Dot',
        //     },
        //     {
        //       key: 'Invisible',
        //       label: 'Invisible',
        //     },
        //   ],
        // },
        // { label: "Rotate", key: "Rotate", icon: <ContentPasteOutlinedIcon /> },
      ]}>
    </Menu >
  );

  const menu = (
    <Menu mode="vertical" overflowedIndicator={<span>More</span>} >
      <Menu.ItemGroup style={{
        maxHeight: 300, overflowY: 'scroll'
      }}>
          <>
         {passage?.map((item, index) => (
            <Box w="auto" h={40}>
              <Box p="7px" h={20} w={100} backgroundColor={'lightgray'} borderRadius={10}>
                <img key={index} 
                  alt="samsung"
                  src={item}
                  draggable="true"
                  onDragStart={(e) => {
                    itemRef.current = {
                      type: "image",
                      src: e.target.src,
                      id: "item-4"
                    };
                  }}
                />
              </Box>
            </Box>
                ))}
          </>
      </Menu.ItemGroup>
    </Menu>
  );

  let numbers = 1;
  let padd = 0;
  let padd1 = 0;
  const zoomIn = () => {
    const zoom_in = numbers += 0.1;
    const padd_res = visible2 ? padd += 50 : padd += 20;
    const padd_res1 = padd1 += 40;
    document.getElementById('zoom_out').style.scale = zoom_in;
    document.getElementById('zoom_out').style.paddingTop = padd_res1 + "px";
    document.getElementById('zoom_out').style.paddingLeft = padd_res + "px";
  }

  const zoomOut = () => {
    const zoom_out = numbers -= 0.1;
    const padd_res = visible2 ? padd -= 50 : padd -= 20;
    const padd_res1 = padd1 -= 40;
    document.getElementById('zoom_out').style.scale = zoom_out;
    document.getElementById('zoom_out').style.paddingTop = padd_res1 + "px";
    document.getElementById('zoom_out').style.paddingLeft = padd_res + "px";
  }

  const divideClick = (ele) => {
    setDivided(ele);
  }

  const toast = useToast()

  //tables 

  const [mainDisplay, setMainDisplay] = useState("none");
  const [newTable, setNewTable] = useState(null);
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("")
  

  const createTable = (e) => {
    const id = e.target.id;
    const [ind1, ind2] = id.split("_").slice(1);
    const rows = [];
    for (let i = 0; i < ind1; i++) {
      const cols = [];
      for (let j = 0; j < ind2; j++) {
        cols.push(<input key={i + "_" + j} className={`new_inp new_inp_${i}_${j}`} />);
      }
      rows.push( 
        <div  key={i}>
          {cols}
          <br />
        </div>
      );
    }
    setNewTable(
      <div className="newtable">
        {rows}
        <br />
      </div>
    );
  
  };
  
  const fixWidth = (e) => {
    const newInps = document.getElementsByClassName("new_inp");
    for (let i = 0; i < newInps.length; i++) {
      newInps[i].style.width = e.target.value + "px";
    }
    setWidth(e.target.value);
  };

  const fixHeight = (e) => {
    const newInps = document.getElementsByClassName("new_inp");
    for (let i = 0; i < newInps.length; i++) {
      newInps[i].style.height = e.target.value + "px";
    }
    setHeight(e.target.value);
  };

  const toggleTable = () => {
    setMainDisplay((prev) => (prev === "none" ? "block" : "none"));
  };
  //response 

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
useEffect(() => {
  function handleResize() {
    setWindowWidth(window.innerWidth);
  }
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

const shouldRenderComponent = windowWidth <1199;


  return (<>
    <div>
      {shouldRenderComponent && <Respo />}
      {/* {!shouldRenderComponent && <MyLargeComponent />} */}
    </div>
    <div className='dashboard'>
      <div className='logout' id='logout'>
        <div>
          <img src={logo} className='logo titleTip' title='EDUVELS' onClick={() => history('/home')} />
        </div>
        {/* <button
          type="button"
          class="btn btn-primary"
          data-mdb-toggle="modal" 
          data-mdb-target="#exampleModal"
          style={{ height: "40px", width: "150px" }}
        >
          Share
        </button> */}
        <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", width: "300px" }}>
          <div className='menu1'>
          <Button p={5} onClick={Recent}  className='blink'  ><SaveIcon/>Save</Button>
            {/* <div className="dropdown">
              <button className="menu-button dropdown-toggle blink" id="dropdownMenuButton" onClick={Recent}
                data-mdb-toggle="dropdown" aria-expanded="false"><img className='download-image' style={{ width: '16px' }} src={save} />
               Save
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li><a className="dropdown-item" onClick={generatepdf}><img className='download-image' src={download} />Download</a></li>
                <li>
                  <a className="dropdown-item" onClick={Recent}><img className='download-image' style={{ width: '16px' }} src={save} />Save</a>
                </li>
              </ul>
            </div> */}
          </div>
          <div className='shareBtn'>
            <button
              type="button"
              class="btn btn-primary"
              data-mdb-toggle="modal"
              data-mdb-target="#exampleModal"
              style={{ padding: "8px 20px", fontSize: "15px", textTransform: "none", display: "flex" }}
              >
              <img src={share} style={{ width: "25px", height: "25px" }} />
              Share
            </button>

          </div>
        </div>
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Who You Want To Share ?</h5>
                <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                  <a className="dropdown-item" onClick={generatepdf}><img className='download-image' src={download} />Download</a>
                <Form noValidate validated={validated} >
                  <Form.Group as={Col} mb="3" >
                    <Form.Label  >Enter Mail ID:</Form.Label>
                    <Form.Control type="email" placeholder="Enter Email" required onChange={(e) => { setValidated(e.target.value) }} />
                    <Form.Control.Feedback type="invalid">Required Email</Form.Control.Feedback>
                  </Form.Group>
                  {/* <Form.Label class="col-form-label">Give Access:</Form.Label>
                  <Form.Group style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <Form.Group style={{ width: "70px", display: "flex", justifyContent: "space-around" }}>
                      <Form.Check type="radio" name="share_access" id="view" value="view"
                      //  feedback="Required View or Edit"
                        // feedbackType="invalid"
                        //  checked={selectedOption === 'view'}
                          onChange={radioChange} required />
                      <Form.Label for="view">View</Form.Label>
                    </Form.Group>
                    <Form.Group style={{ width: "70px", display: "flex", justifyContent: "space-around" }}>
                      <Form.Check type="radio" name="share_access" id="edit" value="edit" 
                      // checked={selectedOption === 'edit'}
                       onChange={radioChange} required />
                      <Form.Label for="edit">Edit</Form.Label>
                    </Form.Group>
                  </Form.Group> */}
                  <div class="modal-footer">
                    <Buttons type="button" data-mdb-dismiss="modal" onClick={() => {
                      axios.patch(`${apiLocal}recent/viewed`, { id: recentPages.state.item._id, email: validated }).then((res) => {
                        console.log(res.data);
                      })
                      setValidated('')
                    }}>Only View</Buttons>
                    <Buttons type="button" class="btn btn-primary" onClick={() => {
                      axios.patch(`${apiLocal}recent/edit`, { id: recentPages.state.item._id, email: validated }).then((res) => {
                        console.log(res.data);
                      })
                      setValidated('')
                    }}>View & Edit</Buttons>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Flex flexDir='row'>
        {/* nav */}
        <Flex flexDir='column' w="25%" h='calc(100vh - 60px)'>
          <Flex flexDir='row'>
            {/* nav list,icon */}
            <Flex backgroundImage='linear-gradient(to right, #15A8E1, #5DC8A7, #00DCCF)' w='100%'>
              <Tabs display='flex' flexDir='row' variant='unstyled' color='#4328B7' w='100%' >
                <TabList display='flex' flexDir='column' alignItems='center' h='calc(100vh - 60px)' w='35%' overflowY='scroll' sx={{
                  scrollbarWidth: 'none',
                  '::-webkit-scrollbar': {
                    display: 'none',
                  }
                }}>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center'><img src={elementicon} height={40} width={40} alt="Lines" /><Text color='#232323' marginTop='13px' fontSize="14px">Elements</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={templateicon} height={40} width={40} alt="Lines" /><Text color='#232323' marginTop='13px' fontSize="14px">Template</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={mathsicon} height={40} width={40} alt="maths" /><Text color='#232323' marginTop='13px' fontSize="14px">Maths</Text></Tab>
                  {/* <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={scienceicon} height={40} width={40} alt="titles" /><Text color='#232323' marginTop='13px' fontSize="14px">Science</Text></Tab> */}
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={tableicon} height={40} width={40} alt="reaarrange" /><Text color='#232323' marginTop='13px' fontSize="14px">Tables</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={puzzleicon} height={40} width={40} alt="puzzle" /><Text color='#232323' marginTop='13px' fontSize="14px">Puzzle</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={graphicon} height={40} width={40} alt="graph" /><Text color='#232323' marginTop='13px' fontSize="14px">Graph</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={mapicon} height={40} width={40} alt="shapes" /><Text color='#232323' marginTop='13px' fontSize="14px">Map</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={cardsicon} height={40} width={40} alt="reaarrange" /><Text color='#232323' marginTop='13px' fontSize="14px">Cards</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={uploadicon} height={40} width={40} alt="graph" /><Text color='#232323' marginTop='13px' fontSize="14px">Image Download</Text></Tab>
                  <Tab _selected={{ background: "#ffffff", borderRadius: '5px', w: '100%' }} display='flex' flexDir='column' alignItems='center' marginTop='10px'><img src={foldericon} height={40} width={40} alt="graph" /><Text color='#232323' marginTop='13px' fontSize="14px">Folder</Text></Tab>

                </TabList>
                <Box borderLeft='2px solid #232323'></Box>

                <TabPanels w="65%" h='calc(100vh - 60px)' bg='#ffffff' overflowY='scroll' sx={{
                  scrollbarWidth: 'none',
                  '::-webkit-scrollbar': {
                    width: '15px',
                  },
                  '::-webkit-scrollbar-track': {
                    boxShadow: 'inset 0 0 5px grey',
                    borderRadius: '10px'
                  },
                  '::-webkit-scrollbar-thumb': {
                    background: '#808080',
                    borderRadius: '10px'
                  },
                }}>
                  {/* Elements */}
                  {/* text */}
                  <TabPanel>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Text</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="1"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                          >
                            <Box h='100%'>
                              <Button bg='#FFFFFF' fontWeight='300' fontSize='13px' border="0.5px solid #808080" _hover='off' margin='15px 0 15px' onDragStart={(e) => {
                                itemRef.current = {
                                  type: "text",
                                  text: "EDUVELS",
                                };
                              }} onClick={() => {
                                const hash = btoa(Math.random()).substr(10, 5);
                                const item = {
                                  ...itemRef.current,
                                  hash: hash,
                                  x: 42.5,
                                  y: 300,
                                  text: 'EDUVELS',
                                  type: 'text'
                                };
                                console.log(item)
                                setTexts((text) => [...text, item]);
                                setSelectedId(hash)
                              }}
                                draggable="true"><img src={drag} height='16px' width='10px' />&nbsp; Drag to add Text</Button>

                              <Box >
                                <Text color='#232323' backgroundColor="#E5E9F0" p="5px" fontWeight='600' fontSize='16px'>Number</Text>
                                <Box style={{ display: 'flex' }}>
                                  <input type='number' placeholder='eg: 33' onChangeCapture={e => setNumber(e.target.value)} style={{ width: '60px', height: '40px', fontSize: '13px', border: '0.5px solid #808080', margin: '15px 0 10px', borderRadius: '5px', padding: '10px' }} />&nbsp;
                                  <Button bg='#FFFFFF' fontWeight='400' fontSize='13px' border="0.5px solid #808080" _hover='off' margin='15px 1px 15px'
                                    onDragStart={(e) => {
                                      itemRef.current = {
                                        type: "number",
                                        text: number,
                                      };
                                    }}
                                    draggable="true"
                                    onClick={() => {
                                      const hash = btoa(Math.random()).substr(10, 5);
                                      const item = {
                                        ...itemRef.current,
                                        hash,
                                        x: 300,
                                        y: 300,
                                        text: number,
                                        scaleX: 1,
                                        scaleY: 1,
                                        type: 'number'
                                      };
                                      setTexts((text) => [...text, item]);
                                      setSelectedId(hash)
                                    }}
                                  >
                                    <img src={drag} height='16px' width='10px' />
                                    <p style={{ fontSize: '12px', marginLeft: '5px', display: 'inline-flex' }}>Drag Number</p>
                                  </Button>
                                </Box>
                              </Box>
                              {/* <Box>
                                <Button bg='#FFFFFF' fontWeight='300' fontSize='13px' border="0.5px solid #808080" _hover='off' margin='15px 0 15px' onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "text",
                                    text: "EDUVELS",
                                  };
                                }} onClick={() => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 42.5,
                                    y: 300,
                                    text: 'T',
                                    type: 'text'
                                  };
                                  console.log(item)
                                  setPuzzle((text) => [...text, item]);
                                  setSelectedId(hash)
                                }}
                                  draggable="true"><img src={drag} height='16px' width='10px' />&nbsp; Drag to add Text</Button>
                              </Box> */}
                            </Box>
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Title</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {title?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`TITLE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Lines</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {lines?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index} style={{ padding: '5px' }}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`LINE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Notes</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {notes?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`NOTE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Arrows</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {arrow?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`ARROW${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Squares</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {square?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`SQUARE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Rectangles</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {/* {Rectangles?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`SQUARE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Sentence</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          > */}
                            {rectangle?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`RECT${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Bubbles</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {bubbles?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`BUBBLE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Primer Choices</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {primer?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`PRIMER${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Matching Choices</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {matchingChoice?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`MATCH_CH${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Multiple Choices</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {multipleChoice?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`MULTIPLE-CH${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Structure Choices</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {structureChoice?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`STRUCTURE-CH${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabPanel>
                  {/* template */}
                  <TabPanel>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Boxes</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="2"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {templateImage?.map((item, index) => (
                              <>
                                <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                  <LazyLoadImage key={index} onClick={() => template(index)}
                                    alt="samsung"
                                    src={item.img.map((imge) => imge)}
                                    draggable="true"
                                    onDragStart={(e) => {
                                      itemRef.current = {
                                        type: "image",
                                        src: e.target.src,
                                        id: "item-4"
                                      };
                                    }}
                                  />
                                  <p style={{ fontSize: '12px', textAlign: 'center' }}>{`TMP000${index + 1}`}</p>
                                </Box>
                              </>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Matching</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {primerImage?.map((item, index) => (
                              <>
                                <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                  <LazyLoadImage key={index} onClick={() => primerTemplate(index)}
                                    alt="samsung"
                                    src={item.img.map((imge) => imge)}
                                    draggable="true"
                                    onDragStart={(e) => {
                                      itemRef.current = {
                                        type: "image",
                                        src: e.target.src,
                                        id: "item-4"
                                      };
                                    }}
                                  />
                                  <p style={{ fontSize: '12px', textAlign: 'center' }}>{`TMP000${index + 1}`}</p>
                                </Box>
                              </>
                            ))}
                            {matching?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`MATCHING${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Grouping</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {grouping?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`GROUPING${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Passage</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {passage?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`PASSAGE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Multiple</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {multiple?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`MULTIPLE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Structure</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {structure?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <LazyLoadImage key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`STRUCTURE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabPanel>
                  {/* maths */}
                  <TabPanel>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>All</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={divide}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "division"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "division"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`DIVIDE`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={gram}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "gram"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "gram"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`GRAM`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={kilogram}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "kilogram"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "kilogram"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`KILOGRAM`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={clockstand}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "maths"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "maths"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`CLOCKSTAND`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={abacus}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "abacus"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "abacus"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`ABACUS`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={calendar}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "calendar"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "calendar"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`CALENDAR`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={column}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "column"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "column"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`COLUMN`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={addition}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "add"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "add"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`ADD & SUB`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={grid}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "grid"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "grid"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`GRID`}</p>
                            </Box>
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={abacus1}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "abacus-stimulator"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "abacus-stimulator"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              <p style={{ fontSize: '12px', textAlign: 'center' }}>{`ABACUS STIMULATOR`}</p>
                            </Box>
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    {/* Time */}
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Time</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={clock}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "clock"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "clock"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              {/* <p style={{ fontSize: '12px', textAlign: 'center' }}>{`CLOCK`}</p> */}
                            </Box>
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    {/* pieChart */}
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Fraction</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={piechart}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "piechart"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "piechart"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              {/* <p style={{ fontSize: '12px', textAlign: 'center' }}>{`PIECES`}</p> */}
                            </Box>
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    {/* weight */}
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Volume Of Liquid</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >
                            <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                              <img
                                alt="samsung"
                                src={weight}
                                draggable="true"
                                onDragStart={(e) => {
                                  itemRef.current = {
                                    type: "image",
                                    src: e.target.src,
                                    id: "weight"
                                  };
                                }}
                                onClick={(e) => {
                                  const hash = btoa(Math.random()).substr(10, 5);
                                  const item = {
                                    ...itemRef.current,
                                    hash: hash,
                                    x: 140,
                                    y: 300,
                                    src: e.target.src,
                                    type: 'image',
                                    id: "weight"
                                  };
                                  setImages((image) => [...image, item])
                                }}
                              />
                              {/* <p style={{ fontSize: '12px', textAlign: 'center' }}>{`WEIGHT`}</p> */}
                            </Box>
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Decimals</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >

                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Length</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >

                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Percentage</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >

                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>

                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton className='accord_btn'>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Mass</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={5}>
                          <SimpleGrid
                            spacing="3"
                            columns={1}
                            flexDir="row"
                            alignItems="center"
                            marginTop='10px'
                          >

                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>

                  </TabPanel>
                  {/* science */}
                  {/* <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Science</Text>
                    <SimpleGrid
                      spacing="3"
                      columns={2}
                      flexDir="row"
                      alignItems="center"
                      marginTop='20px'
                    >
                      {science?.map((item, index) => (
                        <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                          <img key={index}
                            alt="samsung"
                            src={item}
                            draggable="true"
                            onDragStart={(e) => {
                              itemRef.current = {
                                type: "image",
                                src: e.target.src,
                                id: "item-4"
                              };
                            }}
                            onClick={onClickImages}
                          />
                          <p style={{ fontSize: '12px', textAlign: 'center' }}>{`SCIENCE${index + 1}`}</p>
                        </Box>
                      ))}
                    </SimpleGrid>
                  </TabPanel> */}
                  {/* tables */}
                  <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Tables</Text>
                    <SimpleGrid
                      spacing="3"
                      columns={2}
                      flexDir="row"
                      alignItems="center"
                      marginTop='20px'
                    >
                      {/* {table?.map((item, index) => ( */}
                        <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                          <img
                          //  key={index}
                            alt="samsung"
                            src={Tables}
                            draggable="true"
                            onDragStart={(e) => {
                              itemRef.current = {
                                type: "image",
                                src: e.target.src,
                                id: "table"
                              };
                            }}
                            onClick={(e) => {
                              const hash = btoa(Math.random()).substr(10, 5);
                              const item = {
                                ...itemRef.current,
                                hash: hash,
                                x: 140,
                                y: 300,
                                src: e.target.src,
                                type: 'image',
                                id: "table"
                              };
                              setImages((image) => [...image, item])
                            }}
                          />
                          <p style={{ fontSize: '12px', textAlign: 'center' }}>
                            {/* {`TABLE${index + 1}`} */}
                            Tables
                            </p>
                        </Box>
                      {/* ))} */}
                    </SimpleGrid>
                  </TabPanel>
                  {/* Puzzle */}
                  <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Puzzle</Text>
                    <SimpleGrid
                      spacing="3"
                      columns={1}
                      flexDir="row"
                      alignItems="center"
                      marginTop='20px'
                    >
                      <Box>
                        <img
                          alt="samsung"
                          src={rectangles}
                          draggable="true"
                          onDragStart={(e) => {
                            itemRef.current = {
                              src: e.target.src,
                              type: "image",
                              id: "puzzle"
                            };
                          }}
                          onClick={(e) => {
                            const hash = btoa(Math.random()).substr(10, 5);
                            const item = {
                              ...itemRef.current,
                              hash: hash,
                              x: 140,
                              y: 300,
                              src: e.target.src,
                              type: "image",
                              id: "puzzle"
                            };
                            console.log(item);
                            setImages((image) => [...image, item])
                          }}
                        />
                      </Box>
                      <Box style={{ display: 'flex' }}>
                        <input type='text' placeholder='Aa' onChangeCapture={e => setAlpha(e.target.value)} style={{ width: '60px', height: '40px', fontSize: '13px', border: '0.5px solid #808080', margin: '15px 0 10px', borderRadius: '5px', padding: '10px' }} />&nbsp;
                        <Button bg='#FFFFFF' fontWeight='400' fontSize='13px' border="0.5px solid #808080" _hover='off' margin='15px 1px 15px'
                          onDragStart={(e) => {
                            itemRef.current = {
                              type: "text1",
                              text: alpha,
                            };
                          }}
                          draggable="true"
                          onClick={() => {
                            const hash = btoa(Math.random()).substr(10, 5);
                            const item = {
                              ...itemRef.current,
                              hash,
                              x: 300,
                              y: 300,
                              text: alpha,
                              type: 'text1'
                            };
                            console.log(item)
                            setTexts((text) => [...text, item]);
                            setSelectedId(hash)
                          }}
                        >
                          <img src={drag} height='16px' width='10px' />
                          <p style={{ fontSize: '12px', marginLeft: '5px', display: 'inline-flex' }}>Drag or Click</p>
                        </Button>
                      </Box>
                    </SimpleGrid>
                  </TabPanel>
                  {/* Graph */}
                  <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Graph</Text>
                    <SimpleGrid
                      p="10px"
                      spacing="10"
                      columns={2}
                      flexDir="row"
                      alignItems="center"
                      marginTop='20px'
                    >
                      <Box>
                        <img
                          alt="samsung"
                          src={barchart}
                          draggable="true"
                          onDragStart={(e) => {
                            itemRef.current = {
                              type: "image",
                              src: e.target.src,
                              id: "barchart"
                            };
                          }}
                          onClick={(e) => {
                            const hash = btoa(Math.random()).substr(10, 5);
                            const item = {
                              ...itemRef.current,
                              hash: hash,
                              x: 140,
                              y: 300,
                              src: e.target.src,
                              type: 'image',
                              id: "barchart"
                            };
                            setImages((image) => [...image, item])
                          }}
                        />
                      </Box>
                    </SimpleGrid>
                  </TabPanel>
                  {/* Map */}
                  <TabPanel>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Buildings</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {mapBuildings?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <img key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`BUILDING${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Roads</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {mapRoads?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <img key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`ROAD${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                    <Accordion allowToggle>
                      <AccordionItem>
                        <AccordionButton>
                          <Box as="span" flex='1' textAlign='left'>
                            <Text color='#232323' fontWeight='600' p="5px" fontSize='16px'>Images</Text>
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={2}>
                          <SimpleGrid
                            spacing="3"
                            columns={2}
                            flexDir="row"
                            alignItems="center"
                            marginTop='20px'
                            marginBottom='20px'
                          >
                            {mapImage?.map((item, index) => (
                              <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                                <img key={index}
                                  alt="samsung"
                                  src={item}
                                  draggable="true"
                                  onDragStart={(e) => {
                                    itemRef.current = {
                                      type: "image",
                                      src: e.target.src,
                                      id: "item-4"
                                    };
                                  }}
                                  onClick={onClickImages}
                                />
                                <p style={{ fontSize: '12px', textAlign: 'center' }}>{`IMAGE${index + 1}`}</p>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabPanel>
                  {/* Cards */}
                  <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Cards</Text>
                    <SimpleGrid
                      spacing="3"
                      columns={2}
                      flexDir="row"
                      alignItems="center"
                      marginTop='20px'
                    >
                      {cards?.map((item, index) => (
                        <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                          <img key={index}
                            alt="samsung"
                            src={item}
                            draggable="true"
                            onDragStart={(e) => {
                              itemRef.current = {
                                type: "image",
                                src: e.target.src,
                                id: "item-4"
                              };
                            }}
                            onClick={onClickImages}
                          />
                          <p style={{ fontSize: '12px', textAlign: 'center' }}>{`CARD${index + 1}`}</p>
                        </Box>
                      ))}
                    </SimpleGrid>
                  </TabPanel>
                  {/* Image Download*/}
                  <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Image Download</Text>
                    <Box >
                      <form onSubmit={handleSubmit}>
                        <Input p='10px' type='file' border='off' marginTop="10px" onChange={handleChange} />
                        <Button p='10px' backgroundColor='#6853C2' color='#FFFFFF' _hover='off' marginTop="10px" type='submit'>Upload</Button></form>
                      <br />
                      <hr />
                      <SimpleGrid
                        p="10px"
                        spacing="10"
                        columns={2}
                        flexDir="row"
                        alignItems="center"
                        marginTop='20px'
                      >
                        {img.map((data) => (
                          <Box>
                            <img
                              key={data._id}
                              id="shape"
                              alt="lion"
                              src={`${data.img}`}
                              style={{ backgroundColor: 'transparent' }}
                              draggable="true"
                              onDragStart={(e) => {
                                itemRef.current = {
                                  type: "image",
                                  src: e.target.src,
                                  id: "s21"
                                };
                              }}
                              onClick={onClickImages}
                            />
                          </Box>
                        ))}
                      </SimpleGrid>
                    </Box>
                  </TabPanel>
                  {/* Folder */}
                  <TabPanel pt='10px'>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Trace</Text>
                    <SimpleGrid
                      spacing="10"
                      columns={1}
                      flexDir="row"
                      alignItems="center"
                    >
                      <Box display={'flex'} flexDir={'column'}>
                        {/* trace letter */}
                        <input type='text' placeholder='AaBbCc' onChangeCapture={e => setAlphabet(e.target.value)} style={{ fontSize: '13px', border: '0.5px solid #808080', margin: '10px 0 0 0', borderRadius: '5px', padding: '10px' }} />
                        <Button p='20px' bg='#FFFFFF' fontWeight='400' w='100%' fontSize='13px' border="0.5px solid #808080" _hover='off' margin='10px 0 10px 0'
                          onDragStart={(e) => {
                            itemRef.current = {
                              type: "Trace",
                              text: alphabet,
                            };
                          }}
                          draggable="true"
                          onClick={() => {
                            const hash = btoa(Math.random()).substr(10, 5);
                            const item = {
                              ...itemRef.current,
                              hash: hash,
                              x: 42.5,
                              y: 300,
                              text: alphabet,
                              type: 'Trace'
                            };
                            console.log(item)
                            setTexts((text) => [...text, item]);
                            setSelectedId(hash)
                          }}
                        >
                          <img src={drag} height='16px' width='10px' />&nbsp; Drag Trace
                        </Button>
                      </Box>
                    </SimpleGrid>
                    <Text color='#232323' fontWeight='600' backgroundColor="#E5E9F0" p="5px" fontSize='16px'>Folder</Text>
                    <SimpleGrid
                      spacing="3"
                      columns={2}
                      flexDir="row"
                      alignItems="center"
                      marginTop='20px'
                    >
                      {folder?.map((item, index) => (
                        <Box p="7px" w='100%' backgroundColor={'lightgray'} borderRadius={10}>
                          <img key={index}
                            alt="samsung"
                            src={item}
                            draggable="true"
                            onDragStart={(e) => {
                              itemRef.current = {
                                type: "image",
                                src: e.target.src,
                                id: "item-4"
                              };
                            }}
                          />
                          <p style={{ fontSize: '12px', textAlign: 'center' }}>{`FOLDER${index + 1}`}</p>
                        </Box>
                      ))}
                    </SimpleGrid>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Flex>
          </Flex>
        </Flex>
        {/* drag align design */}
        <Flex flexDir='column' w="70%" h='calc(100vh - 60px)' >
          {/* Tool bar & editor */}
          <Guides
            style={{ width: "100%", height: "30px" }}
          />
          {/* Buttons */}
          <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#D1D1D1", paddingTop: "10px" }}>
            <Box backgroundColor='#D1D1D1' padding="0 10px 10px 0" >
              <Flex p='10px' display="flex" justifyContent="space-between" backgroundColor="#00DCCF" width={visible2 === true ? 842 : 595} margin="auto" border="2px solid #19AADF" borderRadius="5px">

                <img src={ZoomAdd} title='Zoom-In' style={{ width: '30px' }} onClick={zoomIn} />

                <img src={ZoomSub} title='Zoom-Out' style={{ width: '25px' }} onClick={zoomOut} />

                <img src={Reset} title='Reset' style={{ width: '22px' }} onClick={() => {
                  document.getElementById('zoom_out').style.scale = 1;
                  document.getElementById('zoom_out').style.paddingLeft = "0px";
                  document.getElementById('zoom_out').style.paddingTop = "0px";
                }} />

                <img src={orientation} title='Orientation' style={{ width: '22px' }} onClick={() => {
                  setvisible2(!visible2)
                }} />

                <img src={pageNo} title='Page No' style={{ width: '22px' }} onClick={() => {
                  setPagenumber(!pagenumber)
                }} />

                <img src={borderImage} title='Border' style={{ width: '20px' }} onClick={() => {
                  setvisible1(!visible1); setBorderStyleDashed(0); setBorderShadow(false);
                }} />

                {visible1 === true ?
                  <Box display='flex' width='150px' backgroundColor='whitesmoke' marginRight='10px' justifyContent='space-evenly' borderRadius='6px'>

                    <img src={borderImage3} title='Border 1' style={{ width: '20px' }} onClick={() => {
                      setBorderStyleDashed(!borderStyleDashed)
                      setBorderStyleDashed(2)
                    }} />

                    <img src={borderImage4} title='Border 2' style={{ width: '20px' }} onClick={() => {
                      setBorderStyleDashed(!borderStyleDashed)
                      setBorderStyleDashed(1)
                    }} />

                    <img src={borderImage1} title='Border 3' style={{ width: '20px' }} onClick={() => {
                      setBorderStyleDashed(!borderStyleDashed)
                      setBorderStyleDashed(3)
                    }} />

                    <img src={borderImage2} title='Border 4' style={{ width: '20px' }} onClick={() => {
                      setBorderShadow(!borderShadow)
                    }} />
                  </Box>
                  : ''}

                <img src={Undo} style={{ width: '30px', cursor: DeleteUndo.length > 0 ? 'pointer' : 'not-allowed' }} onClick={() => {
                  undoDoc();
                }} />

                <img src={Redo} style={{ width: '30px', cursor: redo.length > 0 ? 'pointer' : 'not-allowed' }} onClick={() => {
                  RedoDoc();
                }} />

                {undoData.length && undoImage.length ? <Button borderRadius="206.4px" onClick={() => {
                  setData((current) => [...current, undoImage]);
                  setPage1((current) => [...current, undoData]);
                  setUndoData([])
                }}
                >Undo</Button> : ''}


              </Flex>
            </Box>
            <Box backgroundColor='#D1D1D1'>
              {view===1?"":
              <Flex>
                {btncheck == 0 ?
                  <Button backgroundColor="#15A8E1" borderRadius="206.4px" _hover='off' color="white" onClick={() => {
                    setSelectedId(null);
                    console.log(stageRef.current)
                    layerRef.current.draw();
                    setTimeout(() => {
                      const dataURL = layerRef.current.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "application/pdf"
                      });
                      downloadURI(dataURL);
                    }, 1000);
                    setbtncheck(1)
                    for (let i = 0; i <= layerRef.current.children.length; i++) {
                      console.log(layerRef.current.children[i].attrs, "ques");
                      if (layerRef.current.children[i].attrs.name) {
                        console.log(layerRef.current.children[i].attrs)
                        setPage((current) => [...current, layerRef.current.children[i].attrs]);
                      }
                    }
                  }}>
                    Save
                  </Button> : ""}

                {btncheck == 1 ?
                  <Button borderRadius="206.4px" onClick={() => {
                    const count = layerRef.current.children.length;
                    setPage1((current) => [...current, page])
                    setPage([])
                    setbtncheck(0)
                    setvisible1(false)
                    setPagenumber(false)
                    setDeleteUndo([])

                    for (let i = 0; i <= count; i++) {
                      layerRef.current.children.pop(0, count).destroy();
                    }
                  }}>Create New</Button> : ""}

                {update >= 0 ? <Button borderRadius="206.4px"
                  onClick={() => {
                    const dataURL = stageRef.current.toDataURL({
                      quality: 1,
                      pixelRatio: 1,
                      mimeType: "application/pdf"
                    });
                    data[update] = dataURL
                    setPage([])
                    setbtncheck(2)
                    for (let i = 0; i < layerRef.current.children.length; i++) {
                      setPage((current) => [...current, layerRef.current.children[i].attrs]);
                    }
                  }}
                >
                  Edit
                </Button > : " "}

                <Button borderRadius="206.4px" onClick={buttonfor}>post</Button>

                {/* <Button borderRadius="206.4px" onClick={btnPost}>GroupPost</Button> */}

                {btncheck == 2 ?
                  <Button backgroundColor="#15A8E1" borderRadius="206.4px" _hover='off' color="white" onClick={() => {
                    page1.forEach((val, index) => {
                      if (index === update) {
                        page1[update] = page
                      }
                    });
                    setupdate(-1)
                    setbtncheck(0)
                    setPage([])
                    const count = layerRef.current.children.length;
                    for (let i = 0; i <= count; i++) {
                      layerRef.current.children.pop(0, count).destroy();
                    }
                  }}>Save</Button> : " "}
              </Flex>
              }
            </Box>
          </Box>
          <Flex h='calc(100vh - 60px)' w='100%' paddingBottom='10px' backgroundColor="#D1D1D1" justifyContent='space-around'
            overflow='scroll' sx={{
              scrollbarWidth: 'none',
              '::-webkit-scrollbar': {
                display: 'none',
              }
            }}
            onDrop={(e) => {
              e.preventDefault();
              const hash = btoa(Math.random()).substr(10, 5);
              // register event position
              stageRef.current.setPointersPositions(e);
              const item = {
                ...stageRef.current.getPointerPosition(),
                ...itemRef.current,
                hash
              };
              if (itemRef.current.type === "image") {
                setImages((images) => [...images, item]);
              } else {
                setTexts((texts) => [...texts, item]);
              }
            }}
            onDragOver={(e) => e.preventDefault()
            }
          >
            <Dropdown overlay={imageDrop === true && selectedId ? menu1 : (rightDrop === true ? menu : '')} trigger={["contextMenu"]} >

              <div id='zoom_out' style={{ paddingLeft: visible2 ? 38 : '' }}
              >
                <Stage
                  id="remove"
                  height={visible2 === true ? 595 : 842}
                  width={visible2 === true ? 842 : 595}
                  style={{
                    backgroundColor: "#FFF",
                    boxShadow: "0px 0px 17px 0px rgb(204 204 204 / 64%)",
                    margin: 'auto',
                  }}
                  ref={stageRef}
                  onTouchStart={checkDeselect}
                  onMouseDown={onMouseDown}
                  onMouseUp={onMouseUp}
                  onMouseMove={onMouseMove}
                >
                  <Layer ref={layerRef}
                    onDragMove={onDragMove}
                    onDragEnd={onDragEnd}
                  >
                    {images.map((image, index) => {
                      return (
                        <AdImage
                          key={`image-${index}`}
                          image={image}
                          stageRef={stageRef}
                          layerRef={layerRef}
                          shapeProps={image}
                          getLength={images.length}
                          setSelectedId={setSelectedId}
                          selectedId={selectedId}
                          isSelected={image.id === selectedId}
                          onSelect={(event) => {
                            const shape = event.target;
                            activeRef.current = shape;
                            setSelectedId(image.hash);
                            if (event.evt.button === 2) {
                              setImageDrop(true);
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "clock") {
                              setdiagram(1)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "gram") {
                              setdiagram(2)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "kilogram") {
                              setdiagram(3)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "weight") {
                              setdiagram(4)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "piechart") {
                              setdiagram(5)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "abacus") {
                              setdiagram(6)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "barchart") {
                              setdiagram(7)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "column") {
                              setdiagram(8)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "puzzle") {
                              setdiagram(9)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "calendar") {
                              setdiagram(10)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "add") {
                              setdiagram(11)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "division") {
                              setdiagram(12)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "grid") {
                              setdiagram(13)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "abacus-stimulator") {
                              setdiagram(14)
                              edit1(image.hash)
                            }
                            if (event.type === 'click' && event.target.attrs.imageId === "table") {
                              setdiagram(15)
                              edit1(image.hash)
                            }
                            if (event.type === 'click') {
                              setImageEdit(true)
                            }
                            if (activeRef.current.attrs.type === 'image') {
                              setTextEdit(false)
                              setRightDrop(false)
                            }
                            if (event.current !== undefined) {
                              let temp = nodesArray;
                              if (!nodesArray.includes(event.current)) temp.push(event.current);
                              setNodes(temp);
                              trRef.current.nodes(nodesArray);
                              trRef.current.nodes(nodesArray);
                              trRef.current.getLayer().batchDraw();
                            }
                          }}
                          onChange={(newAttrs) => {
                            const rects = images.slice();
                            rects[index] = newAttrs;
                            setImages(rects);
                            console.log(rects)
                          }}
                        />
                      );
                    })}
                    {texts.map((text, index) => {
                      return (
                        <TextDisplay
                          key={`text-${index}`}
                          text={text}
                          stageRef={stageRef}
                          layerRef={layerRef}
                          activeRef={activeRef}
                          fontSize={font.size}
                          fontFamily={font.family}
                          shapeProps={text}
                          setSelectedId={setSelectedId}
                          selectedId={selectedId}
                          setFont={(e) => setFont(e)}
                          isSelected={text.id === selectedId}
                          onSelect={(event) => {
                            const shape = event.target;
                            activeRef.current = shape;
                            setSelectedId(text.hash);
                            if (event.current !== undefined) {
                              let temp = nodesArray;
                              if (!nodesArray.includes(event.current)) temp.push(event.current);
                              setNodes(temp);
                              trRef.current.nodes(nodesArray);
                              trRef.current.nodes(nodesArray);
                              trRef.current.getLayer().batchDraw();
                            }
                            if (event.type === 'click') {
                              setTextEdit(true)
                              setRightDrop(true)
                            }
                            if (activeRef.current.attrs.type === 'text') {
                              setImageEdit(false)
                              setImageDrop(false)
                            }
                          }}
                          onChange={(newAttrs) => {
                            const rects = texts.slice();
                            rects[index] = newAttrs;
                            setTexts(rects);
                            console.log(rects)
                          }}
                        />
                      );
                    })}

                    {visible1 === true ?
                      <Rect
                        x={25}
                        y={25}
                        width={visible2 === true ? 792 : 545}
                        height={visible2 === true ? 545 : 792}
                        dash={borderStyleDashed === 2 ? [5, 0.0001, 5] : borderStyleDashed === 1 ? [10, 10] : borderStyleDashed === 3 ? [29, 10, 0.00001, 10] : ''}
                        strokeWidth={2} // border width 
                        stroke="black" // border color
                        shadowBlur={borderShadow === true ? 10 : ''}
                        lineCap='round'
                      /> : null}
                    {pagenumber === true ?
                      <Text1
                        x={visible2 === true ? 410 : 290}
                        y={visible2 === true ? 550 : 795}
                        text={(page1.length >= 0 && update == -1) ? page1.length + 1 : update + 1}
                        fontSize={20}
                      /> : null}

                    {selectedId && (
                      <Transformer
                        ref={trRef}
                        onDragMove={(event) => {
                          const shape = event.target;
                          shape.moveToTop();
                        }}
                        onClick={(event) => {
                          const shape = event.target;
                          shape.moveToTop();

                        }}
                        anchorFill="#2dacf5"
                        anchorStrokeWidth={1}
                        borderStrokeWidth={1}
                        keepRatio
                        boundBoxFunc={(oldBox, newBox) => {
                          // limit resize
                          if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                          }
                          return newBox;
                        }}
                      />
                    )}
                    <Rect fill="rgba(0,0,255,0.5)" ref={selectionRectRef} />
                    {guides.map((item, i) => {
                      return <Line key={i} {...item} />;
                    })}
                  </Layer>
                </Stage>
                <br />
                <Flex overflowX='scroll' width={visible2 === true ? 842 : 595} style={{ display: "flex", position: "relative", OverflowX: 'auto', backgroundColor: '#D1D1D1' }} sx={{
                  '::-webkit-scrollbar': {
                    display: 'none',
                  }
                }}>
                  {data?.map((item, index) => (
                    <div>
                      <button key={index} onClick={() => {
                        let page2 = page1[index]
                        const count = layerRef.current.children.length;
                        for (let i = 0; i <= count; i++) {
                          layerRef.current.children.pop(0, count);
                        }
                        console.log(page2);
                        for (let i = 0; i < page2.length; i++) {
                          if (page2[i].imageUrl) {
                            console.log(page2[i])
                            let line = new Konva.Image(page2[i]);
                            const hash = btoa(Math.random()).substr(10, 5);
                            const item = {
                              ...itemRef.current,
                              hash,
                              x: page2[i].x,
                              y: page2[i].y,
                              src: page2[i].imageUrl,
                              scaleX: page2[i].scaleX,
                              scaleY: page2[i].scaleY,
                              type: page2[i].type
                            };
                            setImages((image) => [...image, item])
                          } else if (page2[i].text) {
                            console.log(page2[i])
                            const hash = btoa(Math.random()).substr(10, 5);
                            const item = {
                              ...itemRef.current,
                              hash,
                              x: page2[i].x,
                              y: page2[i].y,
                              text: page2[i].text,
                              scaleX: page2[i].scaleX,
                              scaleY: page2[i].scaleY,
                              type: page2[i].type
                            };
                            setTexts((text) => [...text, item]);
                          } else {
                            let line = new Konva.Rect(page2[i]);
                            layerRef.current.add(line)
                          }
                        }
                        setupdate(index)
                        setbtncheck()
                      }}><img key={index} src={item} className="imagePreview" height={100} width={100} />
                      </button>
                      <button onClick={() => {
                        onOpen()
                        setdeletevalue(index)
                      }}>
                        <img src={Delete} height={25} width={25} style={{ position: "absolute", top: "0", marginLeft: "-20px" }} />
                      </button>
                      <AlertDialog
                        motionPreset='slideInBottom'
                        leastDestructiveRef={cancelRef}
                        onClose={onClose}
                        isOpen={isOpen}
                        isCentered
                      >
                        <AlertDialogOverlay />
                        <AlertDialogContent>
                          <AlertDialogHeader>Discard Changes?</AlertDialogHeader>
                          <AlertDialogCloseButton />
                          <AlertDialogBody>
                            Are you sure you want to delete the page ?
                          </AlertDialogBody>
                          <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                              No
                            </Button>
                            <Button colorScheme='red' ml={3} onClick={() => {
                              const data1 = data[deletevalue]
                              const data2 = page1[deletevalue]
                              setUndoData(data2)
                              setUndoImage([data1])
                              data.splice(deletevalue, 1)
                              page1.splice(deletevalue, 1)
                              setupdate(-1)
                              onClose();
                              const count = layerRef.current.children.length;
                              for (let i = 0; i <= count; i++) {
                                layerRef.current.children.pop(0, count).destroy();
                              }
                            }}>
                              Delete
                            </Button>
                          </AlertDialogFooter>
                        </AlertDialogContent>
                      </AlertDialog>
                      <span style={{ display: "block", marginLeft: "55px" }}>{index + 1}</span>
                    </div>
                  ))}
                  <Box display='flex' alignItems='center'>
                    <Button marginLeft='20px' marginBottom='25px' onClick={() => {
                      setData(current => [...current, "data:image/png;base64,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"])
                      setPage1(current => [...current, []])
                    }}><img src={addNew} className='image-add' /></Button>
                  </Box>
                </Flex>
              </div>
            </Dropdown>
          </Flex>
          <Guides
            type={"vertical"}
            style={{ width: "30px", height: "90%", position: "absolute" }}
          />
        </Flex>

        <Flex h='100%'
          // width="350px"
          w="25%"
          overflowY='scroll'
          flexDir='column'
          sx={{
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': {
              display: 'none',
            }
          }}
        >

          {/* Text */}
          <Flex h='100%' overflowY='scroll' w='100%'
            sx={{
              scrollbarWidth: 'none',
              '::-webkit-scrollbar': {
                display: 'none',
              },
            }}>
            {textedit === true ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="80vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Font
                  </Text>
                </Box>
                <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                  <Text fontWeight='500' fontSize='14px'>Typeface</Text>
                  <Select placeholder='Times new Roman' w="60%" fontSize='14px' onChange={(e) => setFont({ ...font, family: e.target.value })}>
                    <option value="Arial" style={{ fontFamily: "Arial" }}>
                      Arial
                    </option>
                    <option value="Arial" style={{ fontFamily: "Times New Roman" }}>
                      Times new Roman
                    </option>
                    <option value="Arial Black" style={{ fontFamily: "Arial" }}>
                      Bold
                    </option>
                    <option value="Algerian" style={{ fontFamily: "Algerian" }}>
                      Algerian
                    </option>
                    <option
                      value="Berlin Sans FB"
                      style={{ fontFamily: "Berlin Sans FB" }}
                    >
                      Berlin Sans FB
                    </option>
                    <option
                      value="Comic Sans MS"
                      style={{ fontFamily: "Comic Sans MS" }}
                    >
                      Comic Sans MS
                    </option>
                    <option value="Muli" style={{ fontFamily: "Muli" }}>
                      Google Font Muli
                    </option>
                    <option value="Quicksand" style={{ fontFamily: "Quicksand" }}>
                      Google Font Quicksand
                    </option>
                    <option value="nunito" style={{ fontFamily: "nunito" }}>
                      Google Font Nunito Regular
                    </option>
                    <option value="Raleway Dots" className="trace">
                      Trace
                    </option>
                  </Select>
                </Box>
                <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                  <Text fontWeight='500' fontSize='14px'>Size</Text>
                  <Select placeholder={font.size} marginTop='-7px' w="60%" fontSize='14px' onChange={(e) => setFont({ ...font, size: e.target.value })}>
                    <option value='6'>6</option>
                    <option value='8'>8</option>
                    <option value='10'>10</option>
                    <option value='12'>12</option>
                    <option value='14'>14</option>
                    <option value='16'>16</option>
                    <option value='18'>18</option>
                    <option value='20'>20</option>
                    <option value='24'>24</option>
                    <option value='28'>28</option>
                    <option value='32'>32</option>
                    <option value='36'>36</option>
                    <option value='40'>40</option>
                    <option value='48'>48</option>
                    <option value='56'>56</option>
                    <option value='64'>64</option>
                    <option value='72'>72</option>
                  </Select>
                </Box>
                <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                  <Text fontWeight='500' fontSize='14px'>Letter Spacing</Text>
                  <Input placeholder={font.letterSpacing} w="60%" fontSize='14px' onChange={(e) => setFont({ ...font, letterSpacing: e.target.value })}>

                  </Input>
                </Box>
                <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                  <Text fontWeight='500' fontSize='14px'>Line Height</Text>
                  <Select placeholder={font.lineHeight} w="60%" fontSize='14px' onChange={(e) => setFont({ ...font, lineHeight: e.target.value })}>
                    <option value='1'>1</option>
                    <option value='1.25'>1.25</option>
                    <option value='1.5'>1.5</option>
                    <option value='1.75'>1.75</option>
                    <option value='2'>2</option>
                  </Select>
                </Box>
                <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                  <Text fontWeight='500' fontSize='14px'>Style</Text>
                  <Button _hover='off' background="white" marginLeft='55px' onClick={underline} ><img src={underline1} height='20px' width='23px' style={{ marginLeft: '-5px', }} /></Button>
                  <Button _hover='off' background="white" onClick={italic} ><img src={italic1} height='20px' width='20px' style={{ marginLeft: '-5px' }} /></Button>
                  <Button _hover='off' background="white" onClick={bold}><img src={bold1} height='20px' width='20px' style={{ marginLeft: '-5px', }} /></Button>
                </Box>
                <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                  <Text fontWeight='500' fontSize='14px'>Alignment</Text>
                  <Button p={'5px'} _hover='off' _selected='off' bg='#FFFFFF' marginLeft='15px'
                    onClick={() => { setFont({ ...font, align: 'left' }) }} ><img src={leftAlign} /></Button>
                  <Button p={'5px'} _hover='off' _selected='off' bg='#FFFFFF'
                    onClick={() => { setFont({ ...font, align: 'center' }) }} ><img src={centerAlign} /></Button>
                  <Button p={'5px'} _hover='off' _selected='off' bg='#FFFFFF'
                    onClick={() => { setFont({ ...font, align: 'right' }) }} ><img src={rightAlign} /></Button>
                </Box>
                <Box p="10px" paddingBottom="10px" marginLeft='100px' display="flex" flexDir="initial" justifyContent="space-around">
                  <Box>
                    <Button p={'12px'} _hover='off' _selected='off' bg='#FFFFFF' onClick={() => {
                      setSelectedId(null);
                      setDeleteUndo((current) => [...current, activeRef.current.attrs])
                      activeRef.current.destroy();
                      layerRef.current.draw();
                    }} ><img src={deelte} height='25px' width='25px' /></Button>
                    <Text fontWeight='500' fontSize='14px'>Delete</Text>
                  </Box>
                  <Box>
                    <Button _hover='off' background="white" onClick={Paste} ><img src={duplicate} height='35px' width='35px' /></Button>
                    <Text fontWeight='500' fontSize='14px'>Duplicate</Text>
                  </Box>
                </Box>
              </SimpleGrid> : ""}
          </Flex>

          {/* Image */}
          {imageedit ?
            <>
              <Box paddingBottom="10px">
                <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                  Image
                </Text>
              </Box>
              <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                <Text fontWeight='500' fontSize='14px'>Width :</Text>
                <Input type='number' size='sm' maxW={20} value={scale.scaleX} borderRadius="7px"
                  onChange={(e) => setscale({ ...scale, scaleX: e.target.value })} />
              </Box>
              <Box p="10px" paddingBottom="10px" display="flex" flexDir="initial" justifyContent="space-between">
                <Text fontWeight='500' fontSize='14px'>Height :</Text>
                <Input type='number' size='sm' maxW={20} value={scale.scaleY} borderRadius="7px"
                  onChange={(e) => setscale({ ...scale, scaleY: e.target.value })} />
              </Box>
              {diagram === 9 ? <Box p="10px" paddingBottom="10px" marginLeft='10px' display="flex" flexDir="initial" justifyContent="space-around">
                <Box>
                  {/* left */}
                  <Button _hover='off' _selected='off' bg='#FFFFFF' border='1px solid #808080' borderRadius={50} onClick={() => {
                    const img = activeRef.current.attrs.imageUrl
                    const x = activeRef.current.attrs.x
                    const scaleX = activeRef.current.attrs.scaleX
                    const y = activeRef.current.attrs.y
                    const scaleY = activeRef.current.attrs.scaleY
                    // const txt = activeRef.current.attrs.text
                    const hash = btoa(Math.random()).substr(10, 5);
                    // register event position
                    const item = {
                      ...itemRef.current,
                      src: img,
                      x: x - (scaleX * 71),
                      scaleX: scaleX,
                      scaleY: scaleY,
                      y: y,
                      hash,
                    };
                    setImages((images) => [...images, item]);
                  }} >
                    <img src={Arrows} width='20px' />
                  </Button>
                </Box>
                <Box>
                  <Button _hover='off' _selected='off' bg='#FFFFFF' border='1px solid #808080' borderRadius={50} onClick={() => {
                    const img = activeRef.current.attrs.imageUrl
                    const x = activeRef.current.attrs.x
                    const scaleX = activeRef.current.attrs.scaleX
                    const y = activeRef.current.attrs.y
                    const scaleY = activeRef.current.attrs.scaleY
                    const txt = activeRef.current.attrs.text
                    const hash = btoa(Math.random()).substr(10, 5);
                    // register event position

                    const item = {
                      ...itemRef.current,
                      src: img,
                      scaleX: scaleX,
                      scaleY: scaleY,
                      y: y,
                      x: x + (scaleX * 71),
                      hash,
                    };
                    setImages((images) => [...images, item]);
                  }}>
                    <img src={Arrows} width='20px' style={{ transform: 'rotate(180deg)' }} />
                  </Button>
                </Box>
                <Box>
                  <Button _hover='off' background="white" border='1px solid #808080' borderRadius={50} onClick={() => {
                    const img = activeRef.current.attrs.imageUrl
                    const x = activeRef.current.attrs.x
                    const scaleX = activeRef.current.attrs.scaleX
                    const y = activeRef.current.attrs.y
                    const scaleY = activeRef.current.attrs.scaleY
                    const txt = activeRef.current.attrs.text
                    const hash = btoa(Math.random()).substr(10, 5);
                    // register event position
                    const item = {
                      ...itemRef.current,
                      src: img,
                      x: x,
                      scaleX: scaleX,
                      scaleY: scaleY,
                      y: y - (scaleY * 50),
                      hash,
                    };
                    setImages((images) => [...images, item]);
                  }} >
                    <img src={Arrows} width='20px' style={{ transform: 'rotate(90deg)' }} /></Button>
                </Box>
                <Box>
                  <Button _hover='off' background="white" border='1px solid #808080' borderRadius={50} onClick={() => {
                    const img = activeRef.current.attrs.imageUrl
                    const x = activeRef.current.attrs.x
                    const scaleX = activeRef.current.attrs.scaleX
                    const y = activeRef.current.attrs.y
                    const scaleY = activeRef.current.attrs.scaleY
                    const txt = activeRef.current.attrs.text
                    const hash = btoa(Math.random()).substr(10, 5);
                    // register event position
                    const item = {
                      ...itemRef.current,
                      src: img,
                      x: x,
                      scaleX: scaleX,
                      scaleY: scaleY,
                      y: y + (scaleY * 50),
                      hash,
                    };
                    setImages((images) => [...images, item]);
                  }} >
                    <img src={Arrows} width='20px' style={{ transform: 'rotate(270deg)' }} /></Button>
                </Box>
              </Box>
                : ''}
            </> : ""}

          <Flex h='100%' overflowY='scroll' w='100%'
            sx={{
              scrollbarWidth: 'none',
              '::-webkit-scrollbar': {
                display: 'none',
              },
            }}>

            {/* clock */}
            {bol === ! null && diagram === 1 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' w="100%" >
                  <div className="clock" id='editor'>
                    <div className="hand hour" style={{ transform: `translate(-50%) rotate(${(hours / 12) * 360}deg)` }}></div>
                    <div className="hand minute" style={{ transform: `translate(-50%) rotate(${(mins / 60) * 360}deg)` }}  ></div>
                    <div className="number number0_1"></div>
                    <div className="number number0_2"></div>
                    <div className="number number0_3"></div>
                    <div className="number number0_4"></div>
                    <div className="number number1"><div>1</div></div>
                    <div className="number number0_6"></div>
                    <div className="number number0_7"></div>
                    <div className="number number0_8"></div>
                    <div className="number number0_9"></div>
                    <div className="number number2"><div>2</div></div>
                    <div className="number number1_1"></div>
                    <div className="number number1_2"></div>
                    <div className="number number1_3"></div>
                    <div className="number number1_4"></div>
                    <div className="number number3"><div>3</div></div>
                    <div className="number number1_6"></div>
                    <div className="number number1_7"></div>
                    <div className="number number1_8"></div>
                    <div className="number number1_9"></div>
                    <div className="number number4"><div>4</div></div>
                    <div className="number number2_1"></div>
                    <div className="number number2_2"></div>
                    <div className="number number2_3"></div>
                    <div className="number number2_4"></div>
                    <div className="number number5"><div>5</div></div>
                    <div className="number number2_6"></div>
                    <div className="number number2_7"></div>
                    <div className="number number2_8"></div>
                    <div className="number number2_9"></div>
                    <div className="number number6"><div>6</div></div>
                    <div className="number number3_1"></div>
                    <div className="number number3_2"></div>
                    <div className="number number3_3"></div>
                    <div className="number number3_4"></div>
                    <div className="number number7"><div>7</div></div>
                    <div className="number number3_6"></div>
                    <div className="number number3_7"></div>
                    <div className="number number3_8"></div>
                    <div className="number number3_9"></div>
                    <div className="number number8"><div>8</div></div>
                    <div className="number number4_1"></div>
                    <div className="number number4_2"></div>
                    <div className="number number4_3"></div>
                    <div className="number number4_4"></div>
                    <div className="number number9"><div>9</div></div>
                    <div className="number number4_6"></div>
                    <div className="number number4_7"></div>
                    <div className="number number4_8"></div>
                    <div className="number number4_9"></div>
                    <div className="number number10"><div>10</div></div>
                    <div className="number number5_1"></div>
                    <div className="number number5_2"></div>
                    <div className="number number5_3"></div>
                    <div className="number number5_4"></div>
                    <div className="number number11"><div>11</div></div>
                    <div className="number number5_6"></div>
                    <div className="number number5_7"></div>
                    <div className="number number5_8"></div>
                    <div className="number number5_9"></div>
                    <div className="number number12"><div>12</div></div>
                    <div className="number number6_1"></div>
                    <div className="number number6_2"></div>
                    <div className="number number6_3"></div>
                    <div className="number number6_4"></div>
                  </div><br />
                  <div style={{ display: "flex" }}> Hours: <Input type='number' value={hours} size='sm' maxW={20} min={10} variant='filled'
                    onChange={(e) => setHours(e.target.value)} />&nbsp;
                    Mins: <Input type='number' value={mins} size='sm' maxW={20} min={10} variant='filled'
                      onChange={(e) => setmins(e.target.value)} />&nbsp;
                    <br /><br /></div>
                  <Button mt={4}
                    onClick={async () => {
                      const element = document.getElementById('editor'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid>
              : ""}

            {/* gram */}
            {bol === ! null && diagram === 2 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' >
                  <div className="clock1" id="editor1">
                    <div className="hand hour" style={{ transform: `translate(-50%) rotate(${(g / 1000) * 360}deg)` }}></div>
                    <div className="num num1_1"><div>100</div></div>
                    <div className="num num1_2"><div>200</div></div>
                    <div className="num num1_3"><div>300</div></div>
                    <div className="num num1_4"><div>400</div></div>
                    <div className="num num1_5"><div>500</div></div>
                    <div className="num num1_6"><div>600</div></div>
                    <div className="num num1_7"><div>700</div></div>
                    <div className="num num1_8"><div>800</div></div>
                    <div className="num num1_9"><div>900</div></div>
                    <div className="num num2"><div>0</div>g</div>
                  </div><br />
                  grams: <Input type='number' size='sm' maxW={20} defaultValue={15} min={10} variant='filled' value={g}
                    onChange={(e) => setg(e.target.value)} /><br /><br />
                  <Button mt={4}
                    onClick={async () => {
                      const element = document.getElementById('editor1'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL);
                    }} >Change</Button>

                </Box>
              </SimpleGrid> : ""}

            {/* kilogram */}
            {bol === ! null && diagram === 3 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' >
                  <div className="clock1" id="editor2">
                    <div className="hand hour" style={{ transform: `translate(-50%) rotate(${(kg / 10) * 360}deg)` }}></div>
                    <div className="num num1_1"><div>1</div></div>
                    <div className="num num1_2"><div>2</div></div>
                    <div className="num num1_3"><div>3</div></div>
                    <div className="num num1_4"><div>4</div></div>
                    <div className="num num1_5"><div>5</div></div>
                    <div className="num num1_6"><div>6</div></div>
                    <div className="num num1_7"><div>7</div></div>
                    <div className="num num1_8"><div>8</div></div>
                    <div className="num num1_9"><div>9</div></div>
                    <div className="num num2"><div>0</div>kg</div>

                  </div><br />
                  kilogram: <Input type='number' size='sm' maxW={20} defaultValue={15} min={10} variant='filled' value={kg}
                    onChange={(e) => setkg(e.target.value)} /><br />
                  <Button mt={4}
                    onClick={async () => {
                      const element = document.getElementById('editor2'),
                          canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }}>Change</Button>
                </Box>
              </SimpleGrid> : ""}

{/* {Puzzle}
{bol === ! null && diagram == 3 ?
<SimpleGrid
 columns={1}
 flexDir="row"
 h="65vh"
>
<Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' >
                  <div className="clock1" id="editor3">
                    <div className="hand hour" style={{ transform: `translate(-50%) rotate(${(kg / 10) * 360}deg)` }}></div>
                    <div className="num num1_1"><div>1</div></div>
                    <div className="num num1_2"><div>2</div></div>
                    <div className="num num1_3"><div>3</div></div>
                    <div className="num num1_4"><div>4</div></div>
                    <div className="num num1_5"><div>5</div></div>
                    <div className="num num1_6"><div>6</div></div>
                    <div className="num num1_7"><div>7</div></div>
                    <div className="num num1_8"><div>8</div></div>
                    <div className="num num1_9"><div>9</div></div>
                    <div className="num num2"><div>0</div>kg</div>

                  </div><br />
                  Puzzle: <Input type='number' size='sm' maxW={20} defaultValue={15} min={10} variant='filled' value={kg}
                    onChange={(e) => setkg(e.target.value)} /><br />
                  <Button mt={4}
                    onClick={async () => {
                      const element = document.getElementById('editor3'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }}>Change</Button>
                </Box>
</SimpleGrid>
: ""} */}
            {/* beaker */}
            {bol === ! null && diagram === 4 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' >
                  <div id="container1">
                    <div id="beaker">
                      <div id="oval"></div>
                      <div id="liquid" style={{ height: `${l / 3.7}px` }}></div>
                      <div id="line11" className="line"><div className="amount">100</div></div>
                      <div id="line12" className="line1"></div>
                      <div id="line13" className="line"><div className="amount">200</div></div>
                      <div id="line14" className="line1"></div>
                      <div id="line15" className="line"><div className="amount">300</div></div>
                      <div id="line16" className="line1"></div>
                      <div id="line17" className="line"><div className="amount">400</div></div>
                      <div id="line18" className="line1"></div>
                      <div id="line19" className="line"><div className="amount">500</div></div>
                      <div id="line20" className="line1"></div>
                      <div id="line21" className="line"><div className="amount">600</div></div>
                      <div id="line22" className="line1"></div>
                      <div id="line23" className="line"><div className="amount">700</div></div>
                      <div id="line24" className="line1"></div>
                      <div id="line25" className="line"><div className="amount">800</div></div>
                      <div id="line26" className="line1"></div>
                      <div id="line27" className="line"><div className="amount">900</div></div>
                    </div>
                  </div><br />
                  litres <Input type='number' size='sm' maxW={20} min={10} variant='filled' value={l}
                    onChange={(e) => setl(e.target.value)} /><br />
                  <form onSubmit={handleSubmit}>
                    <Button mt={4}
                      onClick={async () => {
                        const element = document.getElementById('container1'),
                          canvas = await html2canvas(element, { backgroundColor: "transparent" })
                        const dataURL = canvas.toDataURL({
                          quality: 1,
                          pixelRatio: 1,
                          mimeType: "image/png"
                        });
                        editsubmit1(dataURL)
                      }}>change</Button>&nbsp;
                  </form>
                </Box>
              </SimpleGrid> : ""}

            {/* pieChart */}
            {bol === ! null && diagram === 5 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box p="10px">
                  <form onSubmit={handleSubmitPie} >
                    Pieces:<Select m={1} maxW={40} display='inline-block' onChange={(e) => { setLabelPieValue(e.target.value) }}>
                      <option value='100'>1</option>
                      <option value='100,100'>2</option>
                      <option value='100,100,100'>3</option>
                      <option value='100,100,100,100'>4</option>
                      <option value='100,100,100,100,100'>5</option>
                      <option value='100,100,100,100,100,100'>6</option>
                      <option value='100,100,100,100,100,100,100'>7</option>
                      <option value='100,100,100,100,100,100,100,100'>8</option>
                      <option value='100,100,100,100,100,100,100,100,100'>9</option>
                      <option value='100,100,100,100,100,100,100,100,100,100'>10</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100'>11</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100'>12</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100'>13</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100'>14</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100,100'>15</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100'>16</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100'>17</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100'>18</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100'>19</option>
                      <option value='100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100,100'>20</option>
                    </Select><br />
                    Colour:<Input type='text' maxW={40} m={1} onChange={(e) => { setDataColour(e.target.value) }} />
                    <Button type="submit">Submit</Button>
                  </form>
                  <div style={{ height: '300px', width: '300px' }}>
                    <canvas className="chart1" id='chart1' width="200" height="200"></canvas>
                  </div>

                  <Button
                    onClick={async () => {
                      const element = document.getElementById('chart1'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid> : ""}

            {/* abacus */}
            {bol === ! null && diagram === 6 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box p="10px">
                  <div class="abacus-holder" id='abacus-holder'>
                    <table id="abacus">
                      <tr class="rows" id="row1">
                      </tr>
                      <tr class="rows" id="row2">
                      </tr>
                      <tr class="rows" id="row3">
                      </tr>
                      <tr class="rows" id="row4">
                      </tr>
                      <tr class="rows" id="row5">
                      </tr>
                      <tr class="rows" id="row6">
                      </tr>
                    </table>

                  </div>
                  <div style={{ display: 'flex' }}>
                    <Input type='number' size='sm' maxW={7} p={2} variant='filled' id="txt6" m={2} onChange={displayabacus} />
                    <Input type='number' size='sm' maxW={7} p={2} variant='filled' id="txt2" m={2} onChange={displayabacus} />
                    <Input type='number' size='sm' maxW={7} p={2} variant='filled' id="txt3" m={2} onChange={displayabacus} />
                    <Input type='number' size='sm' maxW={7} p={2} variant='filled' id="txt4" m={2} onChange={displayabacus} />
                    <Input type='number' size='sm' maxW={7} p={2} variant='filled' id="txt5" m={2} onChange={displayabacus} />
                    <Input type='number' size='sm' maxW={7} p={2} variant='filled' id="txt7" m={2} onChange={displayabacus} />
                  </div>
                  <Button
                    onClick={async () => {
                      const element = document.getElementById('abacus-holder'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid> : ""}

            {/*bar chart*/}
            {bol === ! null && diagram === 7 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box p="10px" display="flex" flexDir="column" justifyContent="center" alignItems="center" >
                  <form onSubmit={handleSubmit1}>
                    <label>Label:</label>
                    <Input
                      type="text"
                      size='sm'
                      p={2}
                      maxW={40}
                      m={2}
                      variant='filled'
                      onChange={(e) => { setLabel(e.target.value) }}
                    />
                    <br />
                    <label>Value:</label>
                    <Input
                      type="text"
                      size='sm'
                      p={2}
                      maxW={40}
                      m={2}
                      variant='filled'
                      onChange={(e) => { setLabelValue(e.target.value) }}
                    />
                    <Button type="submit">Submit</Button>
                    <Select display={'inline-block'} m={2} w={180} onChange={(e) => {
                      setOptionsChart(e.target.value)
                    }}>
                      <option value='pie'>pieChart</option>
                      <option value='bar'>BarChart</option>
                      <option value='line'>LineChart</option>
                      <option value='doughnut'>Doughnut</option>
                    </Select>
                  </form>

                  <div style={{ height: '300px', width: '300px' }}>
                    <canvas id="chart" width="200" height="200"></canvas>
                  </div>
                  <Button mt={3}
                    onClick={async () => {
                      const element = document.getElementById('chart'),
                        canvas = await html2canvas(element, { backgroundColor: "white" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid> : ""}

            {/* column */}
            {bol === ! null && diagram === 8 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' >
                  <label>Column</label>
                  <Input type="text" id="txt1" onChange={demoDisplay} />
                  <Button mt={4} mb={5}
                    colorScheme='blackAlpha'
                    onClick={async () => {
                      const element = document.getElementById('main'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      console.log(dataURL);
                      editsubmit1(dataURL)
                    }}>Change</Button>
                  <div id="main"></div>
                </Box>
              </SimpleGrid> : ""}

            {/* calendar */}
            {bol === ! null && diagram === 10 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box p="10px">
                  <div id='calendar'>
                    <Calendar />
                  </div>
                  <Button
                    onClick={async () => {
                      const element = document.getElementById('calendar'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid> : ""}

            {/* Add & sub */}
            {bol === ! null && diagram === 11 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                  <div>
      <div id="alter">
        {pushedArray.map((item, index) => (
          <input
            key={index}
           style={{textAlign:"center"}}
            className="inp_class"
            onKeyDown={handleKeyDown}
          />
        ))}
      </div>
      <button style={{marginTop:"15px"}} onClick={handleRemove}>remove</button> 
      <div style={{marginTop:"14px"}}></div>
      <Button mt={4} mb={5}
                    colorScheme='blackAlpha'
                    onClick={async () => {
                      const element = document.getElementById('alter'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }}>Change</Button>
    </div>
              </SimpleGrid>
              : ''}

            {/* division */}
            {bol === ! null && diagram === 12 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box p="10px">
                  <div className='divide-inner' id='divide'>
                    <div className='divide-main'>
                      <div className='divide-center divideboxes'>
                        <span id='txts'></span>
                      </div>
                      <div className='divide-left divideboxes'>
                        <span id='txts1'></span>
                      </div>
                      <div className='divide-top divideboxes'>
                        <span id='txts2'></span>
                      </div>
                      {divided === 0 ? <>
                        <span className='divide-line'></span>
                        <div className='divide-down divideboxes'>
                          <span id='txts3'></span>
                        </div>
                      </> : ''}
                      {divided === 1 ? <>
                        <span className='divide-line'></span>
                        <div className='divide-down divideboxes'>
                          <span id='txts3'></span>
                        </div>
                        <div className='divide-down1 divideboxes'>
                          <span id='txts4'></span>
                        </div>
                      </> : ''}
                      {divided === 2 ? <>
                        <span className='divide-line'></span>
                        <div className='divide-down divideboxes'>
                          <span id='txts3'></span>
                        </div>
                        <div className='divide-down1 divideboxes'>
                          <span id='txts4'></span>
                        </div>
                        <div className='divide-down2 divideboxes'>
                          <span id='txts5'></span>
                        </div>
                        <span className='divide-line1'></span>
                      </> : ''}
                      {divided === 3 ? <>
                        <span className='divide-line'></span>
                        <div className='divide-down divideboxes'>
                          <span id='txts3'></span>
                        </div>
                        <div className='divide-down1 divideboxes'>
                          <span id='txts4'></span>
                        </div>
                        <div className='divide-down2 divideboxes'>
                          <span id='txts5'></span>
                        </div>
                        <span className='divide-line1'></span>
                        <div className='divide-down3 divideboxes'>
                          <span id='txts6'></span>
                        </div>
                        <span className='divide-line2'></span>
                      </> : ''}
                    </div>
                  </div>

                  <div className='add'>
                    <Input type="text" id="int1" maxW={12} m={1} p={1} ml='63px' onChange={Division} /><br />
                    <div style={{ display: 'flex' }}>
                      <Input type="text" id="int6" maxW={12} m={1} p={1} onChange={Division} />

                      <div style={{ borderLeft: '2px solid black', borderTop: '2px solid black', width: 'fit-content', padding: '5px' }}>
                        <Input type="text" id="int" className='input-color' maxW={12} p={2} onChange={Division} /><br />  {/* inside */}
                      </div>
                    </div>
                    <Input type="text" id="int2" maxW={12} m={1} p={1} ml='63px' onChange={Division} onClick={() => divideClick(0)} /><br />
                    <div style={{ borderTop: '2px solid black', width: 'fit-content', marginLeft: "60px" }}>
                      <Input type="text" id="int3" maxW={12} m={1} p={1} className="input-color" onChange={Division} onClick={() => divideClick(1)} />
                    </div>
                    <Input type="text" id="int4" maxW={12} m={1} p={1} ml='65px' onChange={Division} onClick={() => divideClick(2)} /><br />

                    <div style={{ borderTop: '2px solid black', width: 'fit-content', marginLeft: "60px", borderBottom: '2px solid black' }}>
                      <Input type="text" id="int5" maxW={12} m={1} p={1} className="input-color" onChange={Division} onClick={() => divideClick(3)} />
                    </div>
                  </div>
                  <Button mt={2}
                    onClick={async () => {
                      const element = document.getElementById('divide'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid>
              : ''}

            {/* Grid */}

            {bol === ! null && diagram === 13 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box padding='10px' >
                  <label>Column</label>
                  <Input type="text" id="txt1" onChange={(e) => {
                    const value = parseInt(e.target.value);
                    setVal(value);
                  }} />
                  <Button mt={4} mb={5}
                    colorScheme='blackAlpha'
                    onClick={async () => {
                      const element = document.getElementById('tbl'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      editsubmit1(dataURL)
                    }}>Change</Button>
                  <div id="tbl">{renderBoxes()}</div>
                </Box>
              </SimpleGrid> : ""}
              {/* //tables */}
              { bol === ! null && diagram === 15 ?
    <SimpleGrid
                    columns={1}
                    flexDir="row"
                    h="65vh"
                    w="100%"
                  >
                      <div>
                      <div id='main-table'>
          <button onClick={toggleTable}>tables</button>
          <div id="main" style={{ display: mainDisplay }}>
            {[...Array(10)].map((_, i) => (
              <div key={i}>
                {[...Array(10)].map((_, j) => (
                  <input  key={i + "_" + j} id={`cellno_${i + 1}_${j + 1}`} onClick={createTable} className="inp_style" />
                ))}
                <br />
              </div>
            ))}
          </div>
          <div id="sub" style={{ marginTop: "20px", display: "flex",flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <form>
              <div style={{ marginBottom: "10px" }}>
                <label htmlFor="width">width : </label>
                <input type="text" onChange={fixWidth} value={width} style={{ marginBottom: "10px" }} placeholder="width" />
              </div>
              <div>
                <label htmlFor="height">height : </label>
                <input type="text" onChange={fixHeight} value={height} style={{ marginBottom: "20px" }} placeholder="height" />
              </div>
            </form>
            <div id="new">{newTable}</div>
          </div>
          </div>
          <Button mt={4} mb={5}
                        colorScheme='blackAlpha'
                        onClick={async () => {
                          const element = document.getElementById('new'),
                            canvas = await html2canvas(element, { backgroundColor: "transparent" })
                          const dataURL = canvas.toDataURL({
                            quality: 1,
                            pixelRatio: 1,
                            mimeType: "image/png"
                          });
                          editsubmit1(dataURL)
                        }}>Change</Button>
        </div>
                  </SimpleGrid>
                  : ''}

            {/* abacus stimulator */}

            {bol === ! null && diagram === 14 ?
              <SimpleGrid
                columns={1}
                flexDir="row"
                h="65vh"
                w="100%"
              >
                <Box paddingBottom="10px" position='sticky' top='0' zIndex={1000}>
                  <Text backgroundColor="#E5E9F0" p="10px" fontWeight='600' fontSize='16px'>
                    Edit Content
                  </Text>
                </Box>
                <Box p="7px">
                  <div id='abacus-stimulator' style={{ width: "265px" }}>
                    <div style={{ border: "2px solid black", display: "flex" }}>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(0)}></div>
                      </div>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(1)}></div>
                      </div>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(2)}></div>
                      </div>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(3)}></div>
                      </div>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(4)}></div>
                      </div>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(5)}></div>
                      </div>
                      <div className="btm_abacus" style={{ width: "fit-content" }}>
                        <div className="str7" onClick={() => select(6)}></div>
                      </div>
                    </div>
                    <div style={{ display: "flex", border: "2px solid black" }}>
                      <div className="btm_abacus">
                        <div className="str0" onClick={() => sel(0)}></div>
                        <div className="str0" onClick={() => sel(1)}></div>
                        <div className="str0" onClick={() => sel(2)}></div>
                        <div className="str0" onClick={() => sel(3)}></div>
                      </div>
                      <div className="btm_abacus">
                        <div className="str1" onClick={() => sel1(0)}></div>
                        <div className="str1" onClick={() => sel1(1)}></div>
                        <div className="str1" onClick={() => sel1(2)}></div>
                        <div className="str1" onClick={() => sel1(3)}></div>
                      </div>
                      <div className="btm_abacus">
                        <div className="str2" onClick={() => sel2(0)}></div>
                        <div className="str2" onClick={() => sel2(1)}></div>
                        <div className="str2" onClick={() => sel2(2)}></div>
                        <div className="str2" onClick={() => sel2(3)}></div>
                      </div>
                      <div className="btm_abacus">
                        <div className="str3" onClick={() => sel3(0)}></div>
                        <div className="str3" onClick={() => sel3(1)}></div>
                        <div className="str3" onClick={() => sel3(2)}></div>
                        <div className="str3" onClick={() => sel3(3)}></div>
                      </div>
                      <div className="btm_abacus">
                        <div className="str4" onClick={() => sel4(0)}></div>
                        <div className="str4" onClick={() => sel4(1)}></div>
                        <div className="str4" onClick={() => sel4(2)}></div>
                        <div className="str4" onClick={() => sel4(3)}></div>
                      </div>
                      <div className="btm_abacus">
                        <div className="str5" onClick={() => sel5(0)}></div>
                        <div className="str5" onClick={() => sel5(1)}></div>
                        <div className="str5" onClick={() => sel5(2)}></div>
                        <div className="str5" onClick={() => sel5(3)}></div>
                      </div>
                      <div className="btm_abacus">
                        <div className="str6" onClick={() => sel6(0)}></div>
                        <div className="str6" onClick={() => sel6(1)}></div>
                        <div className="str6" onClick={() => sel6(2)}></div>
                        <div className="str6" onClick={() => sel6(3)}></div>
                      </div>
                    </div>
                  </div>
                  <Button mt={2}
                    onClick={async () => {
                      const element = document.getElementById('abacus-stimulator'),
                        canvas = await html2canvas(element, { backgroundColor: "transparent" })
                      const dataURL = canvas.toDataURL({
                        quality: 1,
                        pixelRatio: 1,
                        mimeType: "image/png"
                      });
                      console.log(dataURL);
                      editsubmit1(dataURL)
                    }} >change</Button>
                </Box>
              </SimpleGrid>
              : ''}
              
          </Flex>
        </Flex>
      </Flex >
    </div >
    </>)
}

export default Dashboard
